import JSZip from "jszip";
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { ProgressBar } from 'primereact/progressbar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import XMLParser from 'react-xml-parser';
import { BASE_API } from '../../api/Globals';
import excelLogo from '../../assets/img/excelLogo.png';
import DialogDocumento from '../../components/dialogs/DialogDocumento';
import DialogDocumentoCT from '../../components/dialogs/DialogDocumentoCT';
import DialogEditarEvidencia from "../../components/dialogs/DialogEditarEvidencia";
import Menu from '../../components/sturtural/Menu';
import { helpHttp } from '../../helpers/helpHttp';
import { storage } from "../../helpers/storage";


const formInit = {
    cts: [],
    tipoRecibo: null,
    nombreRecibo: '',
    observaciones: '',
    motivo: null,
    selectedCts: [],
    adjuntos: [],
    adjuntoOpcional: []
}

const validationsFromFolioEvidencias = (folio) => {
    let errors = {};
    console.log(folio)
    if (!folio.observaciones.trim()) {
        errors.observaciones = "El campo (Observaciones) es requerido";
    }
    if (!folio.nombreRecibo.trim()) {
        errors.nombreRecibio = "El campo (Nombre recibió) es requerido"
    }
    if (folio.adjuntos.length === 0) {
        errors.adjuntos = "El campo (Evidencias) es requerido"
    } else {
        // Validar tipos de archivo permitidos
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];

        const invalidFiles = folio.adjuntos.filter(adjunto =>
            !allowedTypes.includes(adjunto.type.toLowerCase())
        );

        if (invalidFiles.length > 0) {
            errors.adjuntos = `Archivos no válidos. Solo se permiten archivos PNG, JPG, JPEG o PDF.`;
        }
    }

    return errors;
}

const validationsFromFolioCierre = (folio) => {
    let errors = {};

    if (folio.cts.length === 0) {
        errors.cts = "El campo (CTs) es requerido";
    }
    if (!folio.observaciones.trim()) {
        errors.observaciones = "El campo (Observaciones) es requerido";
    }
    if (!folio.nombreRecibo.trim()) {
        errors.nombreRecibio = "El campo (Nombre recibió) es requerido"
    }
    if (folio.adjuntos.length === 0) {
        errors.adjuntos = "El campo (Evidencias) es requerido"
    } else {
        // Validar tipos de archivo permitidos
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];

        const invalidFiles = folio.adjuntos.filter(adjunto =>
            !allowedTypes.includes(adjunto.type.toLowerCase())
        );

        if (invalidFiles.length > 0) {
            errors.adjuntos = `Archivos no válidos. Solo se permiten archivos PNG, JPG, JPEG o PDF.`;
        }
    }

    return errors;
}

const validationsFromFolioEvidenciasCT = (folio) => {
    let errors = {};

    // if (!folio.observaciones.trim()) {
    //     errors.observaciones = "El campo (Observaciones) es requerido";
    // }
    if (folio.adjuntos.length === 0) {
        errors.adjuntos = "El campo (Evidencias) es requerido"
    } else {
        // Validar tipos de archivo permitidos
        const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];

        const invalidFiles = folio.adjuntos.filter(adjunto =>
            !allowedTypes.includes(adjunto.type.toLowerCase())
        );

        if (invalidFiles.length > 0) {
            errors.adjuntos = `Archivos no válidos. Solo se permiten archivos PNG, JPG, JPEG o PDF.`;
        }
    }

    return errors;
}

const validationsFormFolioRetirar = (folio) => {
    let errors = {};

    if (folio.motivo === null) {
        errors.motivo = "El campo (Motivo) es requerido";
    }

    if (folio.selectedCts.length === 0) {
        errors.selectedCts = "El campo (CTs) es requerido";
    }

    if (!folio.observaciones.trim()) {
        errors.observaciones = "El campo (Observaciones) es requerido";
    }

    return errors;
}

const validationsFromFolioCancelar = (folio) => {
    let errors = {};

    if (!folio.observaciones.trim()) {
        errors.observaciones = "El campo (Observaciones) es requerido";
    }
    return errors;
}

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value)
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

const fetchData = async (item) => {
    try {
        const response = await helpHttp().post(`${BASE_API}Entrega/postSpdEnviaraPendientesMaquila`, {
            body: {
                Opcion: "1",
                CT: item.codigo,
                IdNivel: null,
                IdTurno: null,
                Grado: "",
                Grupo: "",
                NombreTutor: "",
                ApellidoPat: "",
                ApellidoMat: "",
                IdFolioMaquila: item.idFolioMaquila,
                IdUsuario: storage.get("id"),
                IdCicloEscolar: storage.get('ciclo').IdCicloEscolar,
                parametroExtras: ""
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        });
        const data = await response.ITEMS;
        return data;
    } catch (error) {
        console.warn("Aviso: ", error)
    }
};

const fetchDataCierre = async (form, archivo) => {
    try {
        const file1 = archivo[0]
        const file2 = archivo.length > 1 ? archivo[1] : [];
        const arrConsulta = {
            idFolioMaquila: form.idFolioMaquila,
            idUsuario: storage.get("id"),
            idcicloescolar: storage.get('ciclo').IdCicloEscolar,
            iddestinario: form.tipoRecibo,
            nombretutor: form.nombreRecibo,
            apellidoptutor: "",
            apellidomtutor: "",
            IdTipoDocumento: 1,
            TipoArchivo: (`.${file1.name.split('.').pop()}`),
            NombreArchivo: file1.name,
            RutaArchivo: "",
            mensaje: "",
            Resultado: true,
            ParametrosExtra: JSON.stringify(form.cts),
            Foto: file1.base64,
            FotoOpcional: file2.length !== 0 ? file2.base64 : "",
            NombreArchivoOpcional: file2.length !== 0 ? file1.name : "",
            TipoArchivoOpcional: file2.length !== 0 ? (`.${file2.name.split('.').pop()}`) : "",
            RutaArchivoOpcional: ""
        }
        console.log(arrConsulta)
        const response = await helpHttp().post(`${BASE_API}Entrega/ConfirmarEntregaNueva`, {
            body: arrConsulta,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        })
        // .then(res => {
        //     if (res.SUCCESS) {
        //         setLoadingGuardado(false);
        //         onHide("gestionMaquila");
        //         onHide("dialogConfirmar");
        //         obtenerFolios();
        //         obtenerEstadistico();
        //         toast.current.show({ severity: 'success', summary: "Éxito", detail: "Operación realizada correctamente.", life: 5000 })
        //     }
        // })
        return response
    } catch (error) {
        console.warn("Aviso: ", error)
    }
};

const DashboardMaquila = () => {

    const [cadena, setCadena] = useState('');
    const [getEstatus, setGetEstatus] = useState(null)
    const [estatus, setEstatus] = useState(null)
    const [loadingTabla, setLoadingTabla] = useState(false);
    const [guardandoMaquila, setGuardandoMaquila] = useState(false);
    const [nuevaMaquila, setNuevaMaquila] = useState(false);
    const [detalleMaquila, setDetalleMaquila] = useState(false);
    const [gestionMaquila, setGestionMaquila] = useState(false);
    const [cierreMaquila, setCierreMaquila] = useState(false);
    const [dialogDocument, setDialogDocument] = useState(false);
    const [dialogDocumentCT, setDialogDocumentCT] = useState(false);
    const [dialogConfirmar, setDialogConfirmar] = useState(false);
    const [alumnosDialog, setAlumnosDialog] = useState(false);
    const [openDialogEvidencia, setOpenDialogEvidencia] = useState(false);
    const [dialogSupervisiones, setDialogSupervisiones] = useState(false);
    const [lstEstadistico, setLstEstadistico] = useState([]);
    const [lstGetTipoMaquilas, setLstGetTipoMaquilas] = useState(null);
    const [tipoMaquila, setTipoMaquila] = useState(null)
    const [lstMaquilas, setLstMaquilas] = useState([]);
    const [getDestinatario, setGetDestinatario] = useState([]);
    const [lstMaquilaItems, setLstMaquilaItems] = useState([]);
    const [lstUniversoItems, setLstUniversoItems] = useState([]);
    const [lstCts, setLstCts] = useState([]);
    const [lstMotivo, setLstMotivo] = useState([])
    const [selectedItems, setSelectedItems] = useState(null);
    const [selectedUniverso, setSelectedUniverso] = useState(null);
    const [selectedSup, setSelectedSup] = useState(null);
    const [detalleFolio, setDetalleFolio] = useState(null);
    const [selectedFolio, setSelectedFolio] = useState([]);
    const [supervisiones, setSupervisiones] = useState([]);
    const [dataEvidencias, setDataEvidencias] = useState(null);
    const [openEvidencias, setOpenEvidencias] = useState([]);

    const [MaquilaItems, setMaquilaitems] = useState([]);
    const [MaquilaItemsCierre, setMaquilaitemsCierre] = useState([]);

    const [documentos, setDocumentos] = useState([]);
    const [objFolioMaquila, setObjFolioMaquila] = useState(null)
    const [cargandoDetalle, setCargandoDetalle] = useState(false)
    const [procesosFolio, setProcesosFolio] = useState(null);
    const [resolucion, setResolucion] = useState(null);
    const [getResolucion, setGetResolucion] = useState([])
    const [form, setForm] = useState(formInit);
    const [errors, setErrors] = useState(true);
    const [loadingGuardado, setLoadingGuardado] = useState(false)
    const [loadingNuevaMaquila, setLoadingNuevaMaquila] = useState(false)
    const [loadingPendientes, setLoadingPendientes] = useState(false)
    const [loadingMaquilas, setLoadingMaquilas] = useState(false);
    const [loadingNomina, setLoadingNomina] = useState(false);
    const [bandera, setBandera] = useState(false);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [isPausing, setIsPausing] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [isStarted, setIsStarted] = useState(false);
    const [results, setResults] = useState([]);

    const [currentIndexCierre, setCurrentIndexCierre] = useState(0);
    const [isPausedCierre, setIsPausedCierre] = useState(false);
    const [isPausingCierre, setIsPausingCierre] = useState(false);
    const [isFetchingCierre, setIsFetchingCierre] = useState(false);
    const [isStartedCierre, setIsStartedCierre] = useState(false);
    const [resultsCierre, setResultsCierre] = useState([]);
    const [formateoCierre, setFormateoCierre] = useState([])

    const [showCloseButton, setShowCloseButton] = useState(false);
    const [cargandoFormularioG, setCargandoFormularioG] = useState()
    const [pendientes, setPendientes] = useState(null);
    const [descargarReporte, setDescargarReporte] = useState(false)
    const [loadingDescarga, setLoadingDescarga] = useState(false)
    const [tipoDescarga, setTipoDescarga] = useState('');
    const [escuelasCierre, setEscuelasCierre] = useState(null)

    const [mostrarProgresoEvidencias, setMostrarProgresoEvidencias] = useState(false);
    const [evidenciasProceso, setEvidenciasProceso] = useState([]);
    const [cargandoEvidencias, setCargandoEvidencias] = useState(false);
    const [pausado, setPausado] = useState(false);
    const [idTareaActual, setIdTareaActual] = useState(null);
    const [objActual, setObjActual] = useState(null);
    const [pausaSolicitada, setPausaSolicitada] = useState(false);

    const [loading, setLoading] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);

    const id = storage.get('id');
    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');

    const total = evidenciasProceso.length;
    const done = evidenciasProceso.filter(e => e.status === 'done' || e.status === "error").length;
    const progreso = total ? Math.round((done / total) * 100) : 0;
    const procesoCompletado = total > 0 && done === total;

    const debouncedValue = useDebounce(cadena, 500) //Manda a llamar una funcion que demora la consulta de folios
    const toast = useRef(null)
    var zip = new JSZip();
    const pausaRef = useRef(false)
    // const [habilitarMaquila, setHabilitarMaquila] = useState(false);
    const navigate = useNavigate();

    const [totalExitosos, setTotalExitosos] = useState(0);
    const [totalErrores, setTotalErrores] = useState(0);
    


    const uploadOptions = { style: { display: 'none' } };

    const dialogFuncMap = {
        nuevaMaquila: setNuevaMaquila,
        detalleMaquila: setDetalleMaquila,
        gestionMaquila: setGestionMaquila,
        cierreMaquila: setCierreMaquila,
        dialogDocument: setDialogDocument,
        alumnosDialog: setAlumnosDialog,
        dialogConfirmar: setDialogConfirmar,
        dialogDocumentCT: setDialogDocumentCT,
        dialogSupervisiones: setDialogSupervisiones,
        openDialogEvidencia: setOpenDialogEvidencia
    }

    
    useEffect(() => {
        // if (![1, 5, 3, 19].includes(parseInt(perfil))) {
        //     return navigate('/login');
        // }
    }, [perfil])

    useEffect(() => {
        //console.log('ciclo.IdCicloEscolar', ciclo.IdCicloEscolar )
        if (ciclo !== null)
            if (ciclo.IdCicloEscolar < 6 && perfil == 16)
                navigate('/archivos')
    }, [ciclo]);

    useEffect(() => {
        setForm(formInit)
        setErrors(true)
    }, [resolucion])

    useEffect(() => {
        if (tipoMaquila !== null) {
            setLoadingMaquilas(true);
            helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    tipo: 0,
                    sp: "SpdObtenerResultadosTipo",
                    parametros: [
                        { "IdTipoMaquila": tipoMaquila.idTipoMaquila },
                        { "IdMunicipio": null },
                        { "IdLocalidad": null },
                        { "IdCicloEscolar": ciclo.IdCicloEscolar },
                        { "parametrosExtra": null }
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    setLstMaquilaItems(res.ITEMS)
                }
                setLoadingMaquilas(false);
            })
        }
    }, [tipoMaquila])

    useEffect(() => {
        if ([2, 4].includes(resolucion)) {
            obtenerDestinatario()
        } else if ([5].includes(resolucion)) {
            obtenerListaCts(detalleFolio.idFolioMaquila)
            obtenerLstMotivo()
        }
    }, [resolucion])

    useEffect(() => { // UseEffect que conslta en base al delay de la funcion debouncedValue
        if (ciclo !== null)
            obtenerFolios()
    }, [debouncedValue, estatus])

    useEffect(() => {
        if (tipoMaquila !== null && selectedItems !== null) {
            if (tipoMaquila.idTipoMaquila === 5) {
                const universos = JSON.parse(selectedItems.universo)
                setLstUniversoItems(universos)
                setSelectedUniverso(universos[0]);
            }
        }
    }, [selectedItems])

    useEffect(() => {
        if (ciclo !== null) {
            helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    "sp": "spdGetEstatusMaquila",
                    "Tipo": 0,
                    "parametros": [
                        { "IdCicloEscolar": ciclo.IdCicloEscolar },
                        { "IdUsuario": id }
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    setGetEstatus(res.ITEMS)
                    setEstatus(res.ITEMS[0].idEstatus)
                }
            })

            obtenerEstadistico();
        }

    }, [])

    useEffect(() => {
        // Si no está iniciado, está en pausa, no hay elementos o ya se procesaron todos, no hacer nada
        if (!isStarted || isPaused || !MaquilaItems || MaquilaItems.length === 0 || currentIndex >= MaquilaItems.length) {
            if (isStarted && currentIndex >= MaquilaItems.length) {
                setShowCloseButton(true); // Mostrar botón de cerrar si se completó el proceso
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Alumnos enviados correctamente.", life: 5000 })
            }
            return;
        }

        // Si ya hay una solicitud en curso, no hacer nada
        if (isFetching) {
            return;
        }

        if (MaquilaItems[currentIndex].envio === 1) {
            setCurrentIndex((prevIndex) => {
                // Buscar el siguiente índice donde envio !== 1
                let nextIndex = prevIndex + 1;
                while (nextIndex < MaquilaItems.length && MaquilaItems[nextIndex].envio === 1) {
                    nextIndex++;
                }
                return nextIndex;
            });
            return;
        }

        const fetchNext = async () => {
            setIsFetching(true); // Indicar que se está realizando una solicitud
            var banderaTruena = false
            if (!isPausing) {
                // Realizar la solicitud actual
                const result = await fetchData(MaquilaItems[currentIndex]);
                if (result.Respuesta) {
                    setResults(JSON.parse(result.ResultJson)); // Guardar el resultado
                } else {
                    banderaTruena = true;
                    toast.current.show({ severity: "warn", summary: "Aviso", detail: result.Mensaje })
                }
            }

            // Verificar si se solicitó una pausa durante la solicitud
            if (isPausing || banderaTruena) {
                setIsPaused(true); // Pausar el proceso
                setIsPausing(false); // Restablecer el estado de pausa pendiente
            } else {
                // Solo avanzar al siguiente elemento si no hay una pausa pendiente
                setCurrentIndex((prevIndex) => {
                    // Buscar el siguiente índice donde envio !== 1
                    let nextIndex = prevIndex + 1;
                    while (nextIndex < MaquilaItems.length && MaquilaItems[nextIndex].envio === 1) {
                        nextIndex++;
                    }
                    return nextIndex;
                });
            }

            setIsFetching(false); // Indicar que la solicitud ha terminado
        };

        fetchNext(); // Llamar a la función para procesar la solicitud actual
    }, [currentIndex, isPaused, isStarted, isPausing, isFetching, MaquilaItems]); // Dependencias del efecto

    useEffect(() => {
        // Si no está iniciado, está en pausa, no hay elementos o ya se procesaron todos, no hacer nada
        if (!isStartedCierre || isPausedCierre || !MaquilaItemsCierre || MaquilaItemsCierre.length === 0 || currentIndexCierre >= MaquilaItemsCierre.length) {
            if (isStartedCierre && currentIndexCierre >= MaquilaItemsCierre.length) {
                // console.log(isStartedCierre,  currentIndexCierre, MaquilaItemsCierre.length)
                setShowCloseButton(true); // Mostrar botón de cerrar si se completó el proceso
                setLoadingGuardado(false);
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Alumnos enviados correctamente.", life: 5000 })
            }
            return;
        }

        // Si ya hay una solicitud en curso, no hacer nada
        if (isFetchingCierre) {
            return;
        }

        const fetchNextCierre = async () => {
            setIsFetchingCierre(true); // Indicar que se está realizando una solicitud
            var banderaTruena = false
            if (!isPausingCierre) {
                // Realizar la solicitud actual
                const result = await fetchDataCierre(MaquilaItemsCierre[currentIndexCierre], formateoCierre);
                // console.log(result)
                if (!result.SUCCESS) {
                    // setResults(JSON.parse(result.ResultJson)); // Guardar el resultado
                    banderaTruena = true;
                    toast.current.show({ severity: "warn", summary: "Aviso", detail: result.Mensaje })
                }
            }

            // Verificar si se solicitó una pausa durante la solicitud
            if (isPausingCierre || banderaTruena) {
                setIsPausedCierre(true); // Pausar el proceso
                setIsPausingCierre(false); // Restablecer el estado de pausa pendiente
                setLoadingGuardado(false)
            } else {
                // Solo avanzar al siguiente elemento si no hay una pausa pendiente
                setCurrentIndexCierre((prevIndex) => {
                    // Buscar el siguiente índice donde envio !== 1
                    let nextIndex = prevIndex + 1;
                    return nextIndex;
                });
            }

            setIsFetchingCierre(false); // Indicar que la solicitud ha terminado
        };

        fetchNextCierre(); // Llamar a la función para procesar la solicitud actual
    }, [currentIndexCierre, isPausedCierre, isStartedCierre, isPausingCierre, isFetchingCierre, MaquilaItemsCierre]); // Dependencias del efecto

    const handlePause = () => {
        if (isFetching) {
            // Si hay una solicitud en curso, marcar para pausar después de que termine
            setIsPausing(true);
        } else {
            // Si no hay una solicitud en curso, pausar inmediatamente
            setIsPaused((prev) => !prev);
        }
    };

    const handlePauseCierre = () => {
        if (isFetchingCierre) {
            // Si hay una solicitud en curso, marcar para pausar después de que termine
            setIsPausingCierre(true);
        } else {
            // Si no hay una solicitud en curso, pausar inmediatamente
            setIsPausedCierre((prev) => !prev);
        }
    };

    const progress = MaquilaItems.length > 0 ? ((currentIndex / MaquilaItems.length) * 100).toFixed(2) : 0;
    const progress2 = MaquilaItems.length > 0 ? currentIndex : 0;

    const progressCierre = MaquilaItemsCierre.length > 0 ? ((currentIndexCierre / MaquilaItemsCierre.length) * 100).toFixed(2) : 0;
    const progress2Cierre = MaquilaItemsCierre.length > 0 ? currentIndexCierre : 0;

    const totalAlumnos = form.cts.length > 0 ? form.cts.reduce((total, objeto) => {
        const valor = typeof objeto['TotalAl'] === 'number' ? objeto['TotalAl'] : 0;
        return total + valor;
    }, 0) : 0;

    const onChangeText = (e) => {
        setCadena(e)
    }

    const obtenerEscuelasCierre = (idFolioMaquila, formulario) => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                "sp": "spdGetEscuelaFolioMaquila",
                "Tipo": 0,
                "parametros": [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": idFolioMaquila },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setEscuelasCierre(res.ITEMS)
                setForm({ ...formulario, cts: res.ITEMS.filter(x => x.checked !== "false") })
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Fallo de conexión, intente de nuevo.", life: 5000 })
                setEscuelasCierre(null)
            }
        })
    }

    const obtenerEstadistico = () => {

        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                "sp": "spdGetEstadisticosMaquila",
                "Tipo": 0,
                "parametros": [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdUsuario": id },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLstEstadistico(res.ITEMS)
            }
        })
    }

    const obtenerListaCts = (idFolioMaquila) => {

        helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "spdGetCtsFolioMaquila",
                'tipo': 0,
                'parametros': [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "Id_Folio": idFolioMaquila },
                    { "CCT": "" },
                    { "Opcion": 2 }
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLstCts(res.ITEMS)
            }
        });

    }

    const obtenerLstMotivo = (idFolioMaquila) => {

        helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "SpdListarMotivoRetiroMaquila",
                'tipo': 0,
                'parametros': []
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setForm({ ...form, motivo: res.ITEMS[0] })
                setLstMotivo(res.ITEMS)
            }
        });

    }

    const obtenerDestinatario = () => {

        helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "spdGetDestinatarioMaquila",
                'tipo': 0,
                'parametros': [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdUsuario": id },
                    { "IdTipoUsuario": perfil },
                    { "ParametrosExtra": "" }
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setGetDestinatario(res.ITEMS);
                let formulario = { ...form, tipoRecibo: res.ITEMS[0].idDestinatario, nombreRecibo: "" }
                if (resolucion !== 4) {
                    setForm(formulario)
                } else {
                    obtenerEscuelasCierre(detalleFolio.idFolioMaquila, formulario);
                }
            }
        });

    }

    const obtenerFolios = () => {
        setLoadingTabla(true)
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdGetFolioMaquila",
                tipo: 0,
                parametros: [
                    { "IdUsuario": storage.get("id") },
                    { "IdEstatus": estatus !== null ? estatus : 1 },
                    { "FiltroValor": cadena },
                    { "NumPagina": 0 },
                    { "NumRegistros": 500 },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            setLoadingTabla(false);
            const tabla = res.ITEMS.map(x => { return { ...x, habilitarMaquila: false } })
            setLstMaquilas(tabla)
        })
    }

    const getTipoMaquila = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                "sp": 'spdGetTipoMaquila',
                "Tipo": 0,
                "parametros": [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLstGetTipoMaquilas(res.ITEMS);
                setTipoMaquila(res.ITEMS[0])
            }
        })
    }

    const resetProcess = () => {
        setCurrentIndex(0); // Reiniciar el índice actual
        setIsPaused(false); // Desactivar la pausa
        setIsPausing(false); // Desactivar el estado de pausa pendiente
        setIsFetching(false); // Indicar que no hay una solicitud en curso
        setIsStarted(false); // Desactivar el estado de iniciado

        setCurrentIndexCierre(0); // Reiniciar el índice actual
        setIsPausedCierre(false); // Desactivar la pausa
        setIsPausingCierre(false); // Desactivar el estado de pausa pendiente
        setIsFetchingCierre(false); // Indicar que no hay una solicitud en curso
        setIsStartedCierre(false); // Desactivar el estado de iniciado
        setFormateoCierre([])

        setResults([]); // Limpiar los resultados
        setShowCloseButton(false); // Ocultar el botón de cerrar

        setMaquilaitems([]);
        setMaquilaitemsCierre([]);

        setObjFolioMaquila(null);
    };

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false)
        if (name === 'nuevaMaquila' || name === 'cierreMaquila') {
            if (guardandoMaquila) {
                setGuardandoMaquila(false)
                obtenerFolios();
                resetProcess();
            }
        } else if (name === 'detalleMaquila') {
            setProcesosFolio(null);
            setOpenEvidencias([]);
        } else if (name === 'gestionMaquila') {
            setCargandoFormularioG(false);
            setEvidenciasProceso([]);
            setMostrarProgresoEvidencias(false);
            setPausado(false);
            pausaRef.current = false;
            // setForm(formInit);
            setResolucion(null)
            obtenerEstadistico();
            obtenerFolios();
        }
    }

    const openDialog = (name) => {
        console.log(name)
        dialogFuncMap[`${name}`](true)
        if (name === 'nuevaMaquila') {
            getTipoMaquila()
            setSelectedItems(null)
            setDetalleFolio(null);
            setSelectedUniverso(null);
        } else if (name === 'detalleMaquila') {
            setCargandoFormularioG(false);
        }
    }

    const confirmarMaquila = () => {
        if (tipoMaquila !== null && selectedItems !== null) {
            setLoadingNuevaMaquila(true);
            helpHttp().post(`${BASE_API}Entrega/SpdConfirmarFolioMaquila`, {
                body: {
                    idTipoMaquila: tipoMaquila.idTipoMaquila,
                    idUsuario: id,
                    Supervision: tipoMaquila.idTipoMaquila === 2 ? selectedItems.Id : null,
                    idSede: tipoMaquila.idTipoMaquila === 3 ? selectedItems.Id : null,
                    CT: tipoMaquila.idTipoMaquila === 1 ? selectedItems.Id : null,
                    IdEstatus: 1,
                    IdCicloEscolar: ciclo.IdCicloEscolar,
                    ParametrosExtras: tipoMaquila.idTipoMaquila === 5 ? `[{"IdMunicipio": ${selectedItems.Id}, "IdUniverso": 0}]` : tipoMaquila.idTipoMaquila === 4 ? `[{"IdUniverso": ${selectedItems.Id}}]` : ""
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.ITEMS.succes) {
                    if (tipoMaquila.idTipoMaquila !== 3) {
                        obtenerTotalPendientes({ ...tipoMaquila, ...selectedItems }, res.ITEMS.idFolioMaquila)
                        setMaquilaitems(JSON.parse(res.ITEMS.jsonCT))
                        setObjFolioMaquila(res.ITEMS)
                        setResults(JSON.parse(res.ITEMS.jsonCT))
                    } else {
                        setNuevaMaquila(false);
                        setLoadingNuevaMaquila(false);
                    }
                    obtenerEstadistico();
                    obtenerFolios();
                    toast.current.show({ severity: 'success', summary: "Éxito", detail: 'Operación realizada correctamente.', life: 5000 })
                } else {
                    toast.current.show({ severity: 'warn', summary: "Aviso", detail: res.ITEMS.mensaje, life: 5000 })
                    setLoadingNuevaMaquila(false);
                }
            })
        } else {
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: "Favor de llenar los campos obligatorios.", life: 5000 })
        }
    }

    const obtenerEvidencias = async (detalle) => {
        // const respuesta = await obtenerDetalleFolio(detalle);
        // const find = respuesta.find(x => x.Adjuntos === 1)
        setDataEvidencias(detalle)
        openDialog('openDialogEvidencia');
    }

    const reanudarMaquila = async (detalle) => {
        const resArray = await obtenerResultJsonMaquila(detalle);
        const array = await resArray.map(item => {
            return {
                ...item,
                idFolioMaquila: detalle.idFolioMaquila
            }
        })
        console.log(array);

        setBandera(true);
        setGuardandoMaquila(true)
        setMaquilaitems(array)
        setObjFolioMaquila(detalle)
        setResults(array)
        obtenerTotalPendientes(detalle, detalle.idFolioMaquila)
        // setIsStarted(true)
        // openDialog("nuevaMaquila")

    }


    const obtenerDetalleFolio = async (detalle) => {
        setCargandoDetalle(true)
        const respuesta = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdConsultarDetalleMaquila",
                tipo: 0,
                parametros: [
                    { idFolio: detalle.idFolioMaquila },
                    { idUsuario: id },
                    { idUsuarioTipo: perfil },
                    { IdCicloEscolar: ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            setCargandoDetalle(false)
            if (res.SUCCESS) {
                return res.ITEMS
            } else {
                return [];
            }
        })
        return respuesta;
    }

    const obtenerTotalPendientes = (detalle, folioMaquila) => {
        setLoadingPendientes(true);
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                'sp': 'SpdAvisoGuardarMaquila',
                'tipo': 2,
                'parametros': [
                    { Opcion: 1 },
                    { IdTipoMaquila: detalle.idTipoMaquila },
                    { CT: detalle.idTipoMaquila === 1 ? !detalle.Id ? detalle.valorTipoMaquila : detalle.Id : "" },
                    { Supervision: detalle.idTipoMaquila === 2 ? !detalle.Id ? detalle.valorTipoMaquila : detalle.Id : "" },
                    { IdSede: detalle.idTipoMaquila === 3 ? !detalle.Id ? detalle.valorTipoMaquila : detalle.Id : "" },
                    { IdMunicipio: detalle.idTipoMaquila === 5 ? !detalle.Id ? detalle.IdMunicipio : detalle.Id : "" },
                    { IdUniverso: "" },
                    { IdCicloEscolar: ciclo.IdCicloEscolar },
                    { IdFolioMaquila: !folioMaquila ? folioMaquila : folioMaquila },
                    { ParametrosExtra: "" },
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setPendientes(res.ITEMS)
                openDialog('alumnosDialog')
                setNuevaMaquila(false)
                setLoadingNuevaMaquila(false);
            }
            setLoadingPendientes(false);
        });
    }

    const obtenerResolucion = (detalle) => {
        if (detalle !== null) {
            helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                body: {
                    sp: 'spdGetResolucionMaquila',
                    tipo: 0,
                    parametros: [
                        { IdUsuario: id },
                        { IdTipoUsuario: perfil },
                        { IdFolioMaquila: detalle.idFolioMaquila },
                        { IdCicloEscolar: ciclo.IdCicloEscolar },
                        { ParametrosExtra: null }
                    ]
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    openDialog('gestionMaquila')
                    setGetResolucion(res.ITEMS)
                    setResolucion(res.ITEMS[0].idResolucion)
                }
            })
        }
    }

    const handleConfirmarGestion = async (e) => {
        e.preventDefault();
        const err = [2].includes(resolucion) ? validationsFromFolioEvidencias(form)
            : [7].includes(resolucion) ? validationsFromFolioEvidenciasCT(form)
                : [4].includes(resolucion) ? validationsFromFolioCierre(form)
                    : [5].includes(resolucion) ? validationsFormFolioRetirar(form)
                        : validationsFromFolioCancelar(form);

        setErrors(err);

        if (Object.keys(err).length === 0) {
            if (resolucion !== 4) {
                openDialog("dialogConfirmar")
            } else {
                const allFiles = [...form.adjuntos, ...form.adjuntoOpcional]
                const formateo = await Promise.all(
                    allFiles.map(async (adjunto) => {
                        const base64 = await toBase64(adjunto);
                        return {
                            name: adjunto.name,
                            type: adjunto.type,
                            size: adjunto.size,
                            base64: base64,
                        }
                    })
                );
                const hasError = formateo.some((file) => !['image/jpeg', 'image/png'].includes(file.type));
                if (hasError) {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Solo se permiten imágenes: PNG, JPG, JPEG.", life: 5000 })
                } else {
                    openDialog("dialogConfirmar");
                }
            }

        } else {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Favor de llenar los campos obligatorios.", life: 5000 })
        }
    }

    const handleGestionMaquila = () => {
        const obj = { ...form, idFolioMaquila: detalleFolio.idFolioMaquila, idTipoMaquila: detalleFolio.idTipoMaquila, Folio: detalleFolio.Folio, Codigo: detalleFolio.Codigo };

        setLoadingGuardado(true);
        helpHttp().post(`${BASE_API}Entrega/postSpdGuardarMovimientoFolioMaquila`, {
            body: {
                "idFolioMaquila": obj.idFolioMaquila,
                "idUsuario": id,
                "IdResolucion": resolucion,
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "Valor": obj.observaciones,
                "parametrosExtras": ![2, 4].includes(resolucion) ?
                    [7].includes(resolucion) ?
                        `[{ "NombreArchivos": "${obj.adjuntos.map(a => a.name).join(";")}", "codigo": "${obj.Codigo}" }]` :
                        [5].includes(resolucion) ? `[{"IdMotivoRetiro": ${obj.motivo.IdMotivoRetiro}, "cts": ${JSON.stringify(obj.selectedCts)}}]` : ''
                    : [4].includes(resolucion) ? `[{"idDestinatario": ${obj.tipoRecibo}, "nombre": "${obj.nombreRecibo}", "cts": ${JSON.stringify(form.cts)}}]` :
                        `[{"idDestinatario": ${obj.tipoRecibo}, "nombre": "${obj.nombreRecibo}"}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            try {
                if (res.ITEMS.succes) {
                    if ([2, 4, 7].includes(resolucion)) {
                        if (resolucion !== 7) {
                            handleAdjuntos(res.ITEMS.idTarea, obj)
                        } else {
                            setIdTareaActual(res.ITEMS.idTarea)
                            setObjActual(obj)
                            inicializarProgresoEvidencias();
                            guardarEvidencias(res.ITEMS.idTarea, obj)
                            setMostrarProgresoEvidencias(true);

                            pausaRef.current = false;
                            setPausado(false);
                            onHide('dialogConfirmar');
                        }
                    } else {
                        setLoadingGuardado(false);
                        onHide("gestionMaquila");
                        onHide("dialogConfirmar");
                        obtenerFolios();
                        obtenerEstadistico();
                        toast.current.show({ severity: 'success', summary: "Éxito", detail: "Operación realizada correctamente.", life: 5000 })
                    }

                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.ITEMS.mensaje, life: 5000 })
                    setLoadingGuardado(false);
                }
            } catch (err) {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: res.MESSAGE, life: 5000 })
                setLoadingGuardado(false);
            }
        })
    }

    const formatBytes = (bytes, decimals = 2) => {
        const mb = bytes / (1024 * 1024);
        return mb.toFixed(2) + " MB";
    }

    const inicializarProgresoEvidencias = () => {
        const lista = form.adjuntos.map(adj => ({
            name: adj.name,
            size: adj.size,
            status: 'pending' // pending | uploading | done | error
        }));

        setEvidenciasProceso(lista);
    };

    const pausarCarga = () => {
        pausaRef.current = true;
        setPausaSolicitada(true);
    }

    const reanudarCarga = async () => {
        pausaRef.current = false;
        setPausado(false);
        setPausaSolicitada(false);
        setCargandoEvidencias(true);

        await guardarEvidencias(idTareaActual, objActual)
    }

    const evaluarResultadoFinal = (lista) => {

        const total = lista.length;

        const exitosos = lista.filter(e => e === 'done').length;
        const errores = lista.filter(e => e === 'error').length;

        setTotalExitosos(exitosos);
        setTotalErrores(errores);

        if (exitosos === total) {
            toast.current.show({
                severity: 'success',
                summary: 'Aviso',
                detail: 'Todos los archivos se subieron correctamente.',
                life: 5000
            });
            return;
        }

        if (exitosos > 0 && errores > 0) {
            toast.current.show({
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Algunos archivos se subieron correctamente y otros no pudieron subirse.',
                life: 6000
            });
            return;
        }

        if (errores === total) {
            toast.current.show({
                severity: 'error',
                summary: 'Aviso',
                detail: 'No se pudo subir ningún archivo.',
                life: 6000
            });
            return;
        }
    };

    const guardarEvidencias = async (idTarea, obj) => {

        const allFiles = [...form.adjuntos, ...form.adjuntoOpcional];

        const formateo = await Promise.all(
            allFiles.map(async (adjunto) => {
                const base64 = await toBase64(adjunto);
                return {
                    name: adjunto.name,
                    type: adjunto.type,
                    size: adjunto.size,
                    base64: base64,
                }
            })
        );

        setCargandoEvidencias(true);
        let resultados = []

        for (let i = 0; i < formateo.length; i++) {

            if (pausaRef.current) {
                setCargandoEvidencias(false);
                setPausado(true);
                setPausaSolicitada(false);
                return;
            }

            if (evidenciasProceso[i]?.status === 'done') {
                continue;
            }

            setEvidenciasProceso(prev =>
                prev.map((e, idx) =>
                    idx === i ? { ...e, status: 'uploading' } : e
                )
            );

            const res = await helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                body: {
                    "Opcion": "C",
                    "CicloEscolar": ciclo.Descripcion,
                    "TipoMaquila": "",
                    "TipoArchivo": (`.${formateo[i].name.split('.').pop()}`),
                    "RutaArchivo": "",
                    "id": null,
                    "IdUsuario": id,
                    "NombreArchivo": formateo[i].name,
                    "Folio": obj.idFolioMaquila,
                    "FechaCreate": new Date().toISOString(),
                    "Activo": true,
                    "Archivo": formateo[i].base64,
                    "IdCicloEscolar": ciclo.IdCicloEscolar,
                    "parametrosExtra": `[{"idFolio": ${obj.idFolioMaquila}, "idTarea": ${idTarea}, "idTipoUsuario": ${perfil}, "codigo": "${obj.Codigo}", "idTipoMaquila": "${obj.idTipoMaquila}", "nombreArchivos": "${evidenciasProceso.filter(x => x.status === 'done').map(a => a.name).join(";")}", "opcionOriginal": "C1" }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            });

            setEvidenciasProceso(prev =>
                prev.map((e, idx) =>
                    idx === i ? { ...e, status: res.SUCCESS ? 'done' : 'error' } : e
                )
            );
            resultados.push(res.SUCCESS ? 'done': 'error')

            if (pausaRef.current) {
                setCargandoEvidencias(false);
                setPausado(true);
                setPausaSolicitada(false);
                return;
            }

            if (!res.SUCCESS) {
                continue;
            };
        }
        setCargandoEvidencias(false);

        if (!pausaRef.current) {
            evaluarResultadoFinal(resultados);
        }
    };


    const handleAdjuntos = async (idTarea, form) => {

        const allFiles = [...form.adjuntos, ...form.adjuntoOpcional];

        const formateo = await Promise.all(
            allFiles.map(async (adjunto) => {
                const base64 = await toBase64(adjunto);
                return {
                    name: adjunto.name,
                    type: adjunto.type,
                    size: adjunto.size,
                    base64: base64,
                }
            })
        );

        const subirArchivo = formateo.map(async (adjunto) =>
            helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                body: {
                    "Opcion": "C",
                    "CicloEscolar": ciclo.Descripcion,
                    "TipoMaquila": "",
                    "TipoArchivo": (`.${adjunto.name.split('.').pop()}`),
                    "RutaArchivo": "",
                    "id": null,
                    "IdUsuario": id,
                    "NombreArchivo": adjunto.name,
                    "Folio": form.idFolioMaquila,
                    "FechaCreate": new Date().toISOString(),
                    "Activo": true,
                    "Archivo": adjunto.base64,
                    "IdCicloEscolar": ciclo.IdCicloEscolar,
                    "parametrosExtra": `[{"idFolio": ${form.idFolioMaquila}, "idTarea": ${idTarea}}]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }));

        const results = await Promise.all(subirArchivo)
        const hasError = results.some((res) => !res.SUCCESS);
        if (hasError) {
            toast.current.show({
                severity: 'warn',
                summary: 'Aviso',
                detail: 'Error al subir archivo, favor de verificar.',
                life: 5000,
            });
        } else {
            if ([4].includes(resolucion)) {
                if (![2, 4, 5].includes(detalleFolio.idTipoMaquila)) {
                    handleCierre(form, formateo);
                } else {
                    let objCts = form.cts.map(x => {
                        return {
                            ...form,
                            cts: x,
                        }
                    })
                    setBandera(true);
                    setGuardandoMaquila(true)
                    setMaquilaitemsCierre(objCts);
                    setFormateoCierre(formateo)
                    setObjFolioMaquila(form)
                    onHide('dialogConfirmar');
                    openDialog("cierreMaquila");
                    setIsStartedCierre(true)
                }
            } else {
                setLoadingGuardado(false);
                onHide("gestionMaquila");
                onHide("dialogConfirmar");
                obtenerFolios();
                obtenerEstadistico();
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Operación realizada correctamente.", life: 5000 })
            }
        }

    }

    const handleCierre = (form, archivo) => {
        const file1 = archivo[0]
        const file2 = archivo.length > 1 ? archivo[1] : [];
        const arrConsulta = {
            idFolioMaquila: form.idFolioMaquila,
            idUsuario: id,
            idcicloescolar: ciclo.IdCicloEscolar,
            iddestinario: form.tipoRecibo,
            nombretutor: form.nombreRecibo,
            apellidoptutor: "",
            apellidomtutor: "",
            IdTipoDocumento: 1,
            TipoArchivo: (`.${file1.name.split('.').pop()}`),
            NombreArchivo: file1.name,
            RutaArchivo: "",
            mensaje: "",
            Resultado: true,
            ParametrosExtra: JSON.stringify(form.cts),
            Foto: file1.base64,
            FotoOpcional: file2.length !== 0 ? file2.base64 : "",
            NombreArchivoOpcional: file2.length !== 0 ? file1.name : "",
            TipoArchivoOpcional: file2.length !== 0 ? (`.${file2.name.split('.').pop()}`) : "",
            RutaArchivoOpcional: ""
        }
        helpHttp().post(`${BASE_API}Entrega/ConfirmarEntregaNueva`, {
            body: arrConsulta,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLoadingGuardado(false);
                onHide("gestionMaquila");
                onHide("dialogConfirmar");
                obtenerFolios();
                obtenerEstadistico();
                toast.current.show({ severity: 'success', summary: "Éxito", detail: "Operación realizada correctamente.", life: 5000 })
            }
        })
    }

    const toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result
            .replace('data:', '')
            .replace(/^.+,/, ''));
        reader.onerror = reject;
    });

    const obtenerReporte = (rowData) => {
        setDescargarReporte(true)
        helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
            body: {
                Opcion: 3,
                ParametrosExtra: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}, "idFolio": ${rowData.idFolioMaquila}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                let excel = res.ITEMS;

                let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                let download = document.createElement('a');
                download.href = temp;
                download.download = `DetalleFolio_${rowData.Folio}_${rowData.valorTipoMaquila}_Ciclo_${ciclo.Descripcion}.xlsx`;
                document.body.appendChild(download);
                download.click();
                document.body.removeChild(download);
                setDescargarReporte(false)
            }
        })
    }

    const agruparEvidenciasSecuencial = (data = []) => {
        const resultado = [];
        let padreActual = null;

        data.forEach(item => {
            // Detecta padre
            if (item.idEstatusMaquila === 5 || item.idEstatusMaquila === 10) {
                padreActual = { ...item }; // sin evidencias
                resultado.push(padreActual);
                return;
            }

            // Detecta evidencia
            if (item.idEstatusMaquila === 14 && padreActual) {
                // crea el arreglo solo si no existe
                if (!padreActual.evidencias) {
                    padreActual.evidencias = [];
                }

                padreActual.evidencias.push(item);
                return;
            }

            // Otros estatus
            resultado.push(item);
        });

        return resultado;
    };

    const onOpenDialog = (rowData) => {
        helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "spdGetLinksFolioMaquila",
                'tipo': 0,
                'parametros': [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": rowData.data.idFolioMaquila },
                    { "IdTipoUsuario": storage.get('perfilid') },
                    { "IdUsuario": storage.get("id") },
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.SUCCESS) {

                var xml = (new XMLParser().parseFromString(res.ITEMS[0].AtributosLinksdelListado));
                if (selectedFolio.length === 0) {
                    setCargandoFormularioG(true)
                    if (xml.children[0].children.length === 2) {
                        // setForm(form)
                        setDetalleFolio(rowData.data)
                        obtenerResolucion(rowData.data)
                    }
                    else {
                        openDialog('detalleMaquila');
                        setDetalleFolio(rowData.data);
                        const respuesta = await obtenerDetalleFolio(rowData.data);
                        const resultado = agruparEvidenciasSecuencial(respuesta);
                        setProcesosFolio(resultado)

                    }
                }

            }
        });


    };

    const banderaOnHide = () => {
        if (bandera) {
            setBandera(false);
            onHide('gestionMaquila');
            onHide('cierreMaquila')
        }
        onHide('nuevaMaquila');
        obtenerFolios();
        obtenerEstadistico();
    }

    const Adjuntos = (data) => {
        helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
            body: {
                "Opcion": "S",
                "CicloEscolar": "",
                "TipoMaquila": "",
                "TipoArchivo": "",
                "RutaArchivo": "",
                "id": null,
                "IdUsuario": id,
                "NombreArchivo": "",
                "Folio": data.idFolioMaquila,
                "FechaCreate": new Date().toISOString(),
                "Activo": true,
                "Archivo": "",
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "parametrosExtra": `[{"idFolio": ${data.idFolioMaquila}, "idTarea": ${data.idtarea}, "idTipoUsuario": ${perfil}, "idTipoMaquila": "${data.idTipoMaquila}", "codigo": "${data.Codigo}"}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }

        }).then(res => {
            if (res.SUCCESS) {
                const documentos = res.ITEMS.map(x => {
                    return {
                        ...x,
                        idTipoMaquila: data.idTipoMaquila,
                        Codigo: data.Codigo
                    }
                })
                setDocumentos(documentos);
                openDialog('dialogDocument')
                // setLoading(false);
            }
        })
    }

    const obtenerReporteMaquila = (rowData) => {
        setTipoDescarga('maquila');
        setLoadingDescarga(true);

        helpHttp().post(`${BASE_API}Reportes/spdConsultarExcel`, {
            body: {
                IdCicloEscolar: ciclo.IdCicloEscolar,
                IdFolioMaquila: rowData.idFolioMaquila,
                IdTipoMaquila: rowData.idTipoMaquila === 4 ? 5 : rowData.idTipoMaquila,
                ParametrosExtra: "",
                PROCESO: ciclo.proceso.toUpperCase(),

            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(async (res) => {
            if (res.SUCCESS) {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.ITEMS}`;
                const downloadLink = document.createElement('a');
                const fileName = `Maquila_${rowData.Folio}_${rowData.valorTipoMaquila}_Ciclo_${ciclo.Descripcion}.xlsx`;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoadingDescarga(false);
                setTipoDescarga('');
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Búsqueda sin resultados', life: 5000 })
                setLoadingDescarga(false);
                setTipoDescarga('');
            }
        })
    }

    const formatResumen = async (contenido, idFolioMaquila) => {
        const totales = {
            CCT: "Total",
            "ALUMNOS EN FOLIO": 0,
            POLO: 0,
            "PRENDA ELEGIDA": 0,
            CALZADO: 0,
        };

        // Agrupar los datos por CCT
        const groupedData = contenido.reduce((acc, item) => {
            if (!acc[item.CCT]) {
                // Inicializar el objeto para este CCT
                acc[item.CCT] = {
                    CCT: item.CCT,
                    "ALUMNOS EN FOLIO": 0, // Total de alumnos
                    POLO: 0,    // Total de polos
                    "PRENDA ELEGIDA": 0, // Total de otras prendas
                    CALZADO: 0, // Total de calzado
                };
            }

            // Sumar la cantidad a la categoría correspondiente
            if (item.PRENDA === "CALZADO") {
                acc[item.CCT].CALZADO += item.CANTIDAD;
                totales.CALZADO += item.CANTIDAD;
            } else if (item.PRENDA === "POLO") {
                acc[item.CCT].POLO += item.CANTIDAD;
                totales.POLO += item.CANTIDAD;
            } else {
                acc[item.CCT]["PRENDA ELEGIDA"] += item.CANTIDAD;
                totales["PRENDA ELEGIDA"] += item.CANTIDAD;
            }

            return acc;
        }, {});

        let totalAlumnos
        totalAlumnos = await helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
            body: {
                'sp': "spdGetTotalAlumnoCTMaquila",
                'tipo': 0,
                'parametros': [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "idFolioMaquila": idFolioMaquila },
                    { "parametrosExtras": "" }
                ]
            },
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS);

        totalAlumnos.forEach((escuela) => {
            const codigo = escuela.Codigo;
            const totalAlumno = escuela.totalAlumnos

            if (groupedData[codigo]) {
                groupedData[codigo]["ALUMNOS EN FOLIO"] = totalAlumno;
                totales["ALUMNOS EN FOLIO"] += totalAlumno;
            }
        })

        // Convertir el objeto agrupado en un array
        const result = Object.values(groupedData);
        result.push(totales)
        return result
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            // console.log(module)
            // if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.saveAs(data, fileName + EXCEL_EXTENSION);
            // }
        });
    };

    const obtenerJsonDatosCts = async (rowData) => {
        const array = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdGetJsonDatosCTs",
                tipo: 2,
                parametros: [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": rowData.idFolioMaquila },
                    { "IdUsuario": id },
                    { "CCT": "" },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS.JsonDatosCTs !== null) {
                return res.ITEMS.JsonDatosCTs
            } else {
                return "[]"
            }
        });

        return JSON.parse(array);
    }

    const obtenerJsonDatosSup = async (rowData) => {
        const array = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdGetSupervisionFolioMaquila",
                tipo: 0,
                parametros: [
                    { Opcion: 1 },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": rowData.idFolioMaquila }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS !== null) {
                let items = res.ITEMS.map(x => { return { ...x, idFolioMaquila: rowData.idFolioMaquila } })
                return items
            } else {
                return "[]"
            }
        });

        return array;
    }

    const obtenerResultJsonMaquila = async (rowData) => {
        const array = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "spdGetResultJsonMaquila",
                tipo: 2,
                parametros: [
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": rowData.idFolioMaquila },
                    { "IdUsuario": id },
                    { "CCT": "" },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS.ResultJson)

        return JSON.parse(array);
    }

    const obtenerReporteNominaGrupo = async (rowData) => {
        setTipoDescarga('nómina')
        setLoadingDescarga(true);
        const arr = await obtenerJsonDatosCts(rowData);
        const files = await Promise.all(
            arr.map(async (items) => {
                const file = await Promise.all(
                    items.RAL.map(async (x) => {
                        const arrConsulta = {
                            reporte: ciclo.idProceso === 2 ? 24 : 25,
                            idUsuario: id,
                            Folio: null,
                            parametrosExtra: `[{ "opcion": 25, "IdCicloEscolar": ${ciclo.IdCicloEscolar}, "IdFolioMaquila": ${rowData.idFolioMaquila} }]`,
                            IdEscuela: items.Codigo,
                            IdTurno: x.IdTurno,
                            IdNivel: x.IdNivel,
                            Grado: x.Grado,
                            Grupo: x.Grupo,
                            CURP: ""
                        }
                        return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                            body: arrConsulta,
                            headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Accept": "application/json",
                                'Authorization': `Bearer ${storage.get('token')}`
                            }
                        }).then(res => downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${x.Grado}-${x.Grupo}_Ciclo_${ciclo.Descripcion}.pdf`))
                    })
                )
                return {
                    Codigo: items.Codigo,
                    files: [...file,]
                }
            })
        )
        if (files.length !== 0 && files[0] !== false) {
            comprimirPDFGrupos(files, rowData)
        } else {
            setLoadingDescarga(false);
            setTipoDescarga('');
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: "No se encontraron resultados.", life: 5000 });
        }
    }

    const obtenerReporteNomina = async (rowData) => {
        if (![4, 5].includes(rowData.idTipoMaquila)) {
            setTipoDescarga('nómina')
            setLoadingDescarga(true);
            const arr = await obtenerJsonDatosCts(rowData)

            const files = await Promise.all(
                arr.map(async (items) => {
                    const arrConsulta = {
                        reporte: ciclo.idProceso === 2 ? 24 : 25,
                        idUsuario: id,
                        Folio: null,
                        parametrosExtra: `[{ "opcion": 25, "IdCicloEscolar": ${ciclo.IdCicloEscolar}, "IdFolioMaquila": ${rowData.idFolioMaquila} }]`,
                        IdEscuela: items.Codigo,
                        IdTurno: 0,
                        IdNivel: 0,
                        Grado: "0",
                        Grupo: "",
                        CURP: ""
                    }
                    return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                        body: arrConsulta,
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Accept": "application/json",
                            'Authorization': `Bearer ${storage.get('token')}`
                        }
                    }).then(res => downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${items.Codigo}_Ciclo_${ciclo.Descripcion}.pdf`))
                })
            )
            if (files.length !== 0) {
                comprimirPDFSolo(files, rowData)
            } else {
                setLoadingDescarga(false);
                setTipoDescarga('');
                toast.current.show({ severity: 'warn', summary: "Aviso", detail: "No se encontraron resultados.", life: 5000 });
            }
        } else {
            const arr = await obtenerJsonDatosSup(rowData)
            setSupervisiones(arr)
            setDetalleFolio(rowData)
            openDialog('dialogSupervisiones');
        }
    }

    const obtenerCtNomina = async (supervision) => {
        setLoadingNomina(true);
        let escuelas = await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: 'spdGetSupervisionFolioMaquila',
                opcion: 0,
                parametros: [
                    { "Opcion": 2 },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                    { "IdFolioMaquila": supervision.idFolioMaquila },
                    { "Supervision": supervision.id }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS)

        return escuelas;
    }

    const obtenerPDF = async () => {
        if (selectedSup !== null) {
            const CTs = await obtenerCtNomina(selectedSup)
            if (CTs !== null) {
                const files = await Promise.all(
                    CTs.map(async (items) => {
                        const arrConsulta = {
                            reporte: ciclo.idProceso === 2 ? 24 : 25,
                            idUsuario: id,
                            Folio: null,
                            parametrosExtra: `[{ "opcion": 25, "IdCicloEscolar": ${ciclo.IdCicloEscolar}, "IdFolioMaquila": ${detalleFolio.idFolioMaquila} }]`,
                            IdEscuela: items.id,
                            IdTurno: 0,
                            IdNivel: 0,
                            Grado: "0",
                            Grupo: "",
                            CURP: ""
                        }
                        return await helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
                            body: arrConsulta,
                            headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Accept": "application/json",
                                'Authorization': `Bearer ${storage.get('token')}`
                            }
                        }).then(res => downloadPDFMulti(`data:application/pdf;base64,${res.ITEMS}`, `${items.id}_Ciclo_${ciclo.Descripcion}.pdf`))
                    })
                )
                if (files.length !== 0 && files[0] !== false) {
                    comprimirPDF(files, detalleFolio)
                } else {
                    toast.current.show({ severity: 'warn', summary: "Aviso", detail: "No se encontraron resultados.", life: 5000 });
                }
            } else {
                toast.current.show({ severity: 'warn', summary: "Aviso", detail: "Error interno del servidor. Intente de nuevo.", life: 5000 });
            }
        } else {
            toast.current.show({ severity: 'warn', summary: "Aviso", detail: "Seleccione una supervisión.", life: 5000 });
        }
    }

    const downloadPDFMulti = async (dataurl, filename) => {
        try {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[arr.length - 1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        } catch {
            return false
        }
    }

    const comprimirPDFGrupos = (files, rowData) => {
        const groupedData = files.reduce((acc, item) => {
            if (!acc[item.Codigo]) {
                acc[item.Codigo] = [];
            }
            acc[item.Codigo].push(...item.files); // Add all files to the group
            return acc;
        }, {});

        Object.keys(groupedData).forEach((codigo) => {
            const folder = zip.folder(codigo);
            groupedData[codigo].forEach((file) => {
                folder.file(file.name, file, { base64: true });
            });
        });

        zip.generateAsync({ type: 'base64' }).then((content) => {
            const linkSource = `data:application/zip;base64,${content}`;
            const downloadLink = document.createElement('a');
            const fileName = `Nomina_${rowData.Folio}_${rowData.valorTipoMaquila}_Ciclo_${ciclo.Descripcion}.zip`;

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            setLoadingDescarga(false);
            setTipoDescarga('');
        });
    }

    const comprimirPDFSolo = (files, rowData) => {
        files.forEach((x, index) => {
            zip.file(x.name, x, { base64: true })
            if (files.length === index + 1) {
                zip.generateAsync({ type: "base64" }).then(function (content) {
                    const linkSource = `data:application/zip;base64,${content}`;
                    const downloadLink = document.createElement('a');
                    const fileName = `Nomina_${rowData.Folio}_${rowData.valorTipoMaquila}_Ciclo_${ciclo.Descripcion}.zip`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLoadingDescarga(false);
                    setTipoDescarga('');
                })
            }
        })


    }

    const comprimirPDF = (files, rowData) => {

        files.forEach((x, index) => {
            zip.file(x.name, x, { base64: true })
            if (files.length === index + 1) {
                zip.generateAsync({ type: "base64" }).then(function (content) {
                    const str1 = ciclo.Descripcion.substring(2, 4)
                    const str2 = ciclo.Descripcion.substring(7, 9);
                    const r = ciclo.Descripcion.substring(10, 11);
                    const linkSource = `data:application/zip;base64,${content}`;
                    const downloadLink = document.createElement('a');
                    const fileName = `Nom_${rowData.Folio}_${rowData.valorTipoMaquila}_${[4, 5].includes(rowData.idTipoMaquila) ? selectedSup.id !== "0" ? selectedSup.id : "" : ""}_${ciclo.Descripcion}.zip`;

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLoadingNomina(false);
                    setSelectedSup(null);
                    setDetalleFolio(null);
                    setSupervisiones([]);
                    onHide('dialogSupervisiones');
                })
            }
        })


    }

    const bodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={e => e.stopPropagation()}>
                    {![16, 20].includes(perfil) &&
                        <Button icon='pi pi-refresh' disabled={rowData.idEstatusMaquila !== 8 || rowData.idTipoMaquila === 3} id='btn-accion' className=' p-button-outlined p-0 p-tooltip-target mr-1' data-pr-tooltip='Reanudar envío pendientes' style={{ fontSize: '30px', height: '35px', width: '35px' }}
                            onClick={() => { reanudarMaquila(rowData); }} />
                    }
                    {
                        ([16].includes(perfil) && rowData.Estatus == 'Concluido') &&
                        <Button icon='pi pi-pencil' className="p-button-outlined p-0 p-tooltip-target mr-1" data-pr-tooltip="Editar evidencias" style={{ fontSize: '30px', height: '35px', width: '35px' }}
                            onClick={() => obtenerEvidencias(rowData)} />
                    }
                    <Button icon='pi pi-folder' disabled={rowData.idTipoMaquila === 3 || rowData.idEstatusMaquila === 1 || rowData.idEstatusMaquila === 7 || rowData.idEstatusMaquila === 8} id='btn-accion' className='p-button-outlined p-0 p-tooltip-target mr-1' data-pr-tooltip='Descargar nómina' onClick={() => perfil !== 16 ? obtenerReporteNomina(rowData) : obtenerReporteNominaGrupo(rowData)} style={{ fontSize: '30px', height: '35px', width: '35px' }} />

                    {![16, 20].includes(perfil) &&
                        <Button icon='pi pi-box' disabled={rowData.idEstatusMaquila === 1 || rowData.idEstatusMaquila === 7 || rowData.idEstatusMaquila === 8} id='btn-accion' className='p-button-outlined p-0 p-tooltip-target mr-1' data-pr-tooltip='Descargar maquila' onClick={() => obtenerReporteMaquila(rowData)} style={{ fontSize: '30px', height: '35px', width: '35px' }} />
                    }

                    <Button icon='pi pi-ellipsis-h' className='p-button-outlined p-0 p-tooltip-target mr-1' data-pr-tooltip='Ver detalle' style={{ fontSize: '30px', height: '35px', width: '35px' }} onClick={async () => {
                        openDialog('detalleMaquila');
                        setDetalleFolio(rowData);
                        const respuesta = await obtenerDetalleFolio(rowData)
                        const resultado = agruparEvidenciasSecuencial(respuesta);
                        setProcesosFolio(resultado)
                    }} />
                </div>
            </React.Fragment>
        )
    }

    const bodyTemplateTipoMaq = () => {
        return (
            <div>{detalleFolio.TipoMaquila} ({detalleFolio.valorTipoMaquila})</div>
        )
    }
    const bodyTemplateTotalCts = () => {
        return (
            <div>{detalleFolio.totalcts}</div>
        )
    }

    const placeholderTemplateValorMaquila = (tipoMaquila) => {
        return (
            <>
                {loadingMaquilas === true ?
                    <div style={{ marginTop: '-5px' }}>
                        <ProgressSpinner style={{ height: "20px" }} />
                        <span>Cargando...</span>
                    </div>
                    :
                    <div>{tipoMaquila !== null ? `Seleccione ${tipoMaquila.TipoMaquila.toLowerCase()}` : 'Seleccione tipo maquila'} </div>
                }
            </>
        )
    }

    const bodyTemplateFolio = (item) => {
        return (
            <div>
                <Tooltip target=".p-tooltip-target" />
                <div className="p-tooltip-target" data-pr-tooltip="Gestionar folio">
                    <span class="p-column-title" style={{ display: 'none' }}>Folio: </span>
                    {item}
                </div>
            </div>
        );
    }

    const bodyTemplateTipoMaquila = (item) => {
        return (
            <div>
                <Tooltip target=".p-tooltip-target" />
                <div className="p-tooltip-target" data-pr-tooltip="Gestionar folio">
                    {/* <span class="p-column-title" style={{ display: 'none' }}>Supervisión: </span> */}
                    <span style={{ fontWeight: 'bold' }}>{item.TipoMaquila} ({item.valorTipoMaquila})</span>
                </div>
            </div>
        );
    }

    const bodyTemplateMunicipio = (item) => {
        return (
            <div>
                <Tooltip target=".p-tooltip-target" />
                <div className="p-tooltip-target" data-pr-tooltip="Gestionar folio">
                    <span class="p-column-title" style={{ display: 'none' }}>Municipio: </span>
                    {item}
                </div>
            </div>
        );
    }

    const bodyTemplateEstatus = (rowData) => {
        return <>
            <div className="p-tooltip-target" data-pr-tooltip="Gestionar folio">
                {
                    perfil == 16 && rowData.Estatus == "Pendiente" ? (
                        <Button icon='pi pi-upload' label="Clic aquí para cargar evidencias" className='p-button' style={{ height: '35px', borderRadius: '15px' }}
                            onClick={(e) => { onOpenDialog({ data: rowData }) }}
                        />
                    ) : rowData.Estatus == "Concluido" ?
                        (
                            <Tag rounded value={rowData.Estatus} style={{ background: '#d9efda', color: '#003f03', textTransform: 'uppercase' }}></Tag>
                        ) :
                        (
                            <Tag rounded value={rowData.Estatus} style={{ background: '#9b2f3e30', color: '#9b2f3e', textTransform: 'uppercase' }}></Tag>

                        )
                }
            </div>
        </>
    }




    const obtenerForm = (resolucion) => {
        switch (resolucion) {
            case 2:
                return evidenciasTemplate();
            case 4:
                return cierreTemplate();
            case 5:
                return retirarTemplate();
            case 3:
                return cancelarTemplate();
            case 7:
                return evidenciasCTTemplate();
            default:
                return null;
        }
    }

    const cancelarTemplate = () => (
        <div className='col-12'>
            <label htmlFor="observaciones" style={{ fontWeight: '600' }}><b style={{ color: 'red' }}>*</b> Observaciones</label>
            <InputTextarea className={`w-full ${errors.observaciones && 'p-invalid'}`} id='observaciones' name='observaciones' value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })} />
            {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
        </div>
    );

    const evidenciasTemplate = () => (
        <>
            <div className='col-12 lg:col-6 xl:col-6'>
                <label htmlFor="tipoRecibo" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Recibió</label>
                <Dropdown className='w-full' id='tipoRecibo' name='tipoRecibo' value={form.tipoRecibo} optionValue='idDestinatario' optionLabel='destinatario' options={getDestinatario} onChange={e => setForm({ ...form, tipoRecibo: e.value, nombreRecibo: "" })} />
            </div>
            <div className='col-12 lg:col-6 xl:col-6'>
                <label htmlFor="nombreRecibo" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nombre recibió</label>
                <InputText className={`w-full ${errors.nombreRecibio && 'p-invalid'}`} id='nombreRecibo' name='nombreRecibo' value={form.nombreRecibo} onChange={e => setForm({ ...form, nombreRecibo: e.target.value })} />
                {errors.nombreRecibio && <small className="p-error">{errors.nombreRecibio}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="observaciones" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Observaciones</label>
                <InputTextarea className={`w-full ${errors.observaciones && 'p-invalid'}`} id='observaciones' name='observaciones' value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })} />
                {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="adjuntos" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Evidencias</label>
                <FileUpload className={`w-full ${errors.observaciones && 'p-invalid'}`} id='adjuntos' customUpload={false} multiple={true} uploadOptions={uploadOptions} cancelLabel='Borrar todo' chooseLabel='Elegir archivo' name='adjuntos' emptyTemplate={<p className="m-0" style={{ color: '#707070' }}>Arrastra y suelta archivos aquí para subir.</p>}
                    accept="image/png, image/jpg, image/jpeg, application/pdf" maxFileSize="20000000" invalidFileSizeMessageSummary="{0} : Tamaño de archivo inválido" invalidFileSizeMessageDetail=". El máximo de carga por archivo es 20 MB."
                    onSelect={e => setForm(prevState => ({ ...prevState, adjuntos: [...e.files] }))}
                    onRemove={e => setForm(prevState => ({ ...prevState, adjuntos: prevState.adjuntos.filter(file => file.name !== e.file.name) }))}
                    onClear={() => setForm(prevState => ({ ...prevState, adjuntos: [] }))} />
                {errors.adjuntos && <small className="p-error">{errors.adjuntos}</small>}
            </div>
        </>
    );

    const cierreTemplate = () => (
        <>
            <div className='col-12 lg:col-6 xl:col-6'>
                <label htmlFor="cts" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>CTs</label>
                <MultiSelect filter emptyFilterMessage='Opciones no disponibles' emptyMessage='Opciones no disponibles' className={`w-full ${errors.cts && 'p-invalid'}`} id='cts' name='cts' value={form.cts} options={escuelasCierre} optionLabel='CODIGO' onChange={e => setForm({ ...form, cts: e.value })} />
                {errors.cts && <small className="p-error">{errors.cts}</small>}
            </div>
            <div className='col-12 lg:col-6 xl:col-6'>
                <label htmlFor="tipoRecibo" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Recibió</label>
                <Dropdown className='w-full' id='tipoRecibo' name='tipoRecibo' value={form.tipoRecibo} optionValue='idDestinatario' optionLabel='destinatario' options={getDestinatario} onChange={e => setForm({ ...form, tipoRecibo: e.value, nombreRecibo: "" })} />
            </div>
            <div className='col-12 lg:col-6 xl:col-6'>
                <label htmlFor="nombreRecibo" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nombre recibió</label>
                <InputText className={`w-full ${errors.nombreRecibio && 'p-invalid'}`} id='nombreRecibo' name='nombreRecibo' value={form.nombreRecibo} onChange={e => setForm({ ...form, nombreRecibo: e.target.value })} />
                {errors.nombreRecibio && <small className="p-error">{errors.nombreRecibio}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="observaciones" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Observaciones</label>
                <InputTextarea className={`w-full ${errors.observaciones && 'p-invalid'}`} id='observaciones' name='observaciones' value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })} />
                {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="adjuntos" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Evidencia 1</label>
                <FileUpload className={`w-full ${errors.adjuntos && 'p-invalid'}`} id='adjuntos' customUpload={false} multiple={false} uploadOptions={uploadOptions} cancelLabel='Borrar todo' chooseLabel='Elegir archivo' name='adjuntos' emptyTemplate={<p className="m-0" style={{ color: '#707070' }}>Arrastra y suelta archivos aquí para subir.</p>}
                    accept="image/png, image/jpg, image/jpeg, application/pdf" maxFileSize="2000000" invalidFileSizeMessageSummary="{0} : Tamaño de archivo inválido" invalidFileSizeMessageDetail=". El máximo de carga por archivo es 2 MB."
                    onSelect={e => setForm(prevState => ({ ...prevState, adjuntos: e.files }))}
                    onRemove={e => setForm(prevState => ({ ...prevState, adjuntos: prevState.adjuntos.filter(file => file.name !== e.file.name) }))}
                    onClear={() => setForm(prevState => ({ ...prevState, adjuntos: [] }))} />
                {errors.adjuntos && <small className="p-error">{errors.adjuntos}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="adjuntos" style={{ fontWeight: '600' }}>Evidencia 2</label>
                <FileUpload className={`w-full ${errors.adjuntoOpcional && 'p-invalid'}`} id='adjuntoOpcional' customUpload={false} multiple={false} uploadOptions={uploadOptions} cancelLabel='Borrar todo' chooseLabel='Elegir archivo' name='adjuntoOpcional' emptyTemplate={<p className="m-0" style={{ color: '#707070' }}>Arrastra y suelta archivos aquí para subir.</p>}
                    accept="image/png, image/jpg, image/jpeg, application/pdf" maxFileSize="2000000" invalidFileSizeMessageSummary="{0} : Tamaño de archivo inválido" invalidFileSizeMessageDetail=". El máximo de carga por archivo es 2 MB."
                    onSelect={e => setForm(prevState => ({ ...prevState, adjuntoOpcional: e.files }))}
                    onRemove={e => setForm(prevState => ({ ...prevState, adjuntoOpcional: prevState.adjuntoOpcional.filter(file => file.name !== e.file.name) }))}
                    onClear={() => setForm(prevState => ({ ...prevState, adjuntoOpcional: [] }))} />
                {errors.adjuntoOpcional && <small className="p-error">{errors.adjuntoOpcional}</small>}
            </div>
        </>
    );

    const valueTemplate = (value) => {
        return (
            <React.Fragment>
                <span style={{ color: 'black', fontWeight: 400, fontSize: '14px', textShadow: 'black 0px 0px' }}>{done} / {total}</span>
            </React.Fragment>
        );
    };

    const progresoEvidenciasTemplate = () => (
        <div className="p-8">

            <Tooltip target=".target-tooltip" />

            {progreso == 100 ? (
                <h5>Evidencias procesadas</h5>
            ) :
                (<h5> Subiendo evidencias...</h5>)
            }

            <ProgressBar value={progreso} displayValueTemplate={valueTemplate} />
            {/* <small>{done} de {total} evidencias guardadas</small> */}

            {progreso == 100 &&
                <p>
                    <span> {totalExitosos} guardadas correctamente</span>
                    <span style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '5px', marginRight: '5px' }}>·</span>
                    <span>{totalErrores} con error </span>
                </p>}


            <div className="mt-5 p-2" /*style={{ border: '1px solid #505050', borderRadius: '10px' height: '40vh', overflowY: 'scroll'  }}*/>
                <ul>
                    {evidenciasProceso.map((e, i) => (
                        <li key={i} className="flex align-items-center gap-3 mb-2">
                            {e.status === 'done' && <i className="pi pi-check-circle text-green-500 target-tooltip" data-pr-tooltip='Guardado' style={{ fontSize: '20px' }} />}
                            {e.status === 'uploading' && <i className="pi pi-spin pi-spinner text-black-500 target-tooltip" data-pr-tooltip='Subiendo' style={{ fontSize: '20px' }} />}
                            {e.status === 'pending' && <i className="pi pi-circle text-gray-400 target-tooltip" data-pr-tooltip='Pendiente' style={{ fontSize: '20px' }} />}
                            {e.status === 'error' && <i className="pi pi-times-circle target-tooltip" data-pr-tooltip='Error' style={{ fontSize: '20px', color: 'red' }} />}
                            <div>
                                <span style={{ fontWeight: 600 }}>{e.name}</span>  <br />
                                <span style={{ fontWeight: 300 }}>{formatBytes(e.size)}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );

    const evidenciasCTTemplate = () => (
        <>
            {/* <div className='col-12'>
                <label htmlFor="observaciones" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Observaciones</label>
                <InputTextarea className={`w-full ${errors.observaciones && 'p-invalid'}`} id='observaciones' name='observaciones' value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })} />
                {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
            </div> */}
            <div className='col-12'>
                <label htmlFor="adjuntos" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nóminas firmadas</label>
                <FileUpload className={`w-full ${errors.observaciones && 'p-invalid'}`} id='adjuntos' customUpload={false} multiple={true} uploadOptions={uploadOptions} cancelLabel='Borrar todo' chooseLabel='Elegir archivo' name='adjuntos' emptyTemplate={<p className="m-0" style={{ color: '#707070' }}>Arrastra y suelta archivos aquí para subir.</p>}
                    accept="image/png, image/jpg, image/jpeg, application/pdf" maxFileSize="20000000" invalidFileSizeMessageSummary="{0} : Tamaño de archivo inválido" invalidFileSizeMessageDetail=". El máximo de carga por archivo es 20 MB."
                    onSelect={e => setForm(prevState => ({ ...prevState, adjuntos: [...e.files] }))}
                    onRemove={e => setForm(prevState => ({ ...prevState, adjuntos: prevState.adjuntos.filter(file => file.name !== e.file.name) }))}
                    onClear={() => setForm(prevState => ({ ...prevState, adjuntos: [] }))} />
                {errors.adjuntos && <small className="p-error">{errors.adjuntos}</small>}
            </div>
        </>
    );

    const retirarTemplate = () => (
        <>
            <div className="col-12 lg:col-6">
                <label htmlFor="motivo" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Motivo</label>
                <Dropdown className={`w-full ${errors.motivo && 'p-invalid'}`} id='motivo' name='motivo' value={form.motivo} options={lstMotivo} optionLabel="MotivoRetiro" onChange={e => setForm({ ...form, motivo: e.target.value })} />
                {errors.motivo && <small className="p-error">{errors.motivo}</small>}
            </div>
            <div className="col-12">
                <label htmlFor="selectedCts" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>CTs</label>
                <MultiSelect filter emptyFilterMessage='Opciones no disponibles' emptyMessage='Opciones no disponibles' className={`w-full ${errors.selectedCts && 'p-invalid'}`} id='selectedCts' name='selectedCts' value={form.selectedCts} options={lstCts} optionLabel='codigo' onChange={e => setForm({ ...form, selectedCts: e.value })} />
                {errors.selectedCts && <small className="p-error">{errors.selectedCts}</small>}
            </div>
            <div className='col-12'>
                <label htmlFor="observaciones" style={{ fontWeight: '600' }}><b style={{ marginRight: '5px', color: 'red' }}>*</b>Observaciones</label>
                <InputTextarea className={`w-full ${errors.observaciones && 'p-invalid'}`} id='observaciones' name='observaciones' value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })} />
                {errors.observaciones && <small className="p-error">{errors.observaciones}</small>}
            </div>
        </>
    );

    const footerAlumno = () => {
        return (
            <div className="grid">
                <div className="col-12 text-right">
                    <Button className="p-button-outlined" label="Cancelar" onClick={() => {
                        onHide("alumnosDialog");
                        setGuardandoMaquila(false)
                        obtenerFolios();
                        resetProcess();
                        setPendientes(null)

                    }}></Button>
                    <Button className="p-button" label="Enviar" onClick={() => {
                        setIsStarted(true)
                        obtenerEstadistico();
                        onHide("alumnosDialog")
                        setNuevaMaquila(true)
                        setGuardandoMaquila(true)
                    }}></Button>
                </div>
            </div>
        )
    }

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    const generarReporteMaquila = () => {

        setLoading(true);
        helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
            body: {
                Opcion: 6,
                parametrosExtra: `[{"IdCicloEscolar": ${ciclo.IdCicloEscolar}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                let excel = res.ITEMS;

                let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                const date = new Date();
                let download = document.createElement('a');
                download.href = temp;
                download.download = `Reporte_general_maquila_${formatDate(date)}.xlsx`;
                document.body.appendChild(download);
                download.click();
                document.body.removeChild(download);

                setLoading(false);
            } else {
                setMessage(res.MESSAGE);
                setAviso(true);

                setLoading(false);
            }
        })

    }

    const toggleEvidencias = (index) => {
        setOpenEvidencias(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index) // cerrar
                : [...prev, index] // abrir
        );
    };


    return (
        ciclo !== null &&
        <div>
            <Toast ref={toast} />
            <Menu link='' />
            <Tooltip target=".p-tooltip-target" />

            <h4 className='mb-4 mt-4' style={{ textAlign: 'center', marginTop: '10px' }}>{perfil !== 16 ? 'GESTIÓN DE MAQUILAS' : 'GESTIÓN DE EVIDENCIAS'}</h4>

            <div className='card col-12' style={{ paddingLeft: '20px', paddingRight: '20px', paddingTop: '10px', paddingBottom: '10px', marginBottom: '15px' }}>

                <div className='grid justify-content-center' style={{ marginTop: '1px' }}>
                    <div id='porcentajeEntrega' className='p-0 col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2' style={{ borderRadius: '25px', background: '#efefef' }}>
                        <div style={{ justifyItems: 'center' }}>
                            <span style={{ fontWeight: '600', fontSize: '30px' }}>{lstEstadistico.length > 0 && lstEstadistico[0].totalFolios}
                            </span>
                            <div className="font-small mb-1" style={{ textTransform: 'uppercase', fontWeight: '800' }}>TOTAL</div>
                        </div>
                    </div>
                    {lstEstadistico.map((item, index) =>
                        <div id='porcentajeEntrega' className='col-12 lg:col-2 md:col-6 sm:col-6 xs:col-6 flex justify-content-center lg:mb-0 md:mb-0 mb-2'>
                            <div className='flex'>
                                <i className={`${item.icono} text-2xl md:text-4xl`} style={{ color: '#9b2f3e', alignSelf: 'center', marginRight: '20px' }}></i>
                                <div id='contendorEstadistico' /* style={{ minWidth: '120px' }} */>
                                    <span className="text-900 font-medium text-3xl">{item.contador}
                                    </span>
                                    <div className="text-900 font-small mb-1" style={{ textTransform: 'uppercase' }}>{item.Estatus}</div>
                                </div>
                            </div>

                        </div>
                    )}
                </div>

            </div>

            <div className='card' id='panelsinBorde'>
                <div className='lg:mx-5 md:mx-5 mt-1' style={{ background: '#EFEFEF', padding: '15px 20px 10px 20px', border: '1px solid #dee2e6' }}>
                    <div className='grid'>
                        <div className='col-12 lg:col-3 md:col-4'>
                            <Dropdown value={estatus} options={getEstatus} optionLabel='Estatus' optionValue='idEstatus' className="inputfield w-full" onChange={e => setEstatus(e.value)} />
                        </div>
                        <div className={perfil !== 16 ? 'col-12 lg:col-6 md:col-4' : 'col-12 lg:col-9 md:col-8'}>
                            <span className="p-input-icon-left inputfield w-full">
                                <i className="pi pi-search" />
                                <InputText className="inputfield w-full" id="folio" value={cadena} onChange={(e) => { onChangeText(e.target.value) }} placeholder={perfil !== 16 ? 'Buscador por folio, CT o supervisión' : 'Buscador por folio'} />
                            </span>
                        </div>
                        <div className='col-12 lg:col-3 md:col-4 text-center  lg:text-right md:text-right'>
                            {(![16, 20].includes(perfil)) && <Button className='p-button' label='Crear maquila' icon='pi pi-plus' onClick={() => openDialog('nuevaMaquila')} />}
                            {(![16, 20].includes(perfil)) && <Button className='p-button ml-2' rounded icon='pi pi-download' disabled={loading} tooltip='Descargar reporte' data-pr-position="top" onClick={() => generarReporteMaquila()} />}

                        </div>
                    </div>
                </div>

                <div id='tablaMaquila' className='lg:mx-5 md:mx-5' style={{ border: '1px solid #c8cccf' }}>
                    <DataTable
                        value={lstMaquilas}
                        emptyMessage='No hay registros'
                        style={{ cursor: 'pointer' }}
                        breakpoint="960px"
                        loading={loadingTabla}
                        selection={selectedFolio}
                        onSelectionChange={e => { setSelectedFolio(e.value) }}
                        onRowClick={cargandoFormularioG === true ? '' : onOpenDialog}
                        rowClassName='cursor-pointer'
                        paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                    >
                        <Column header={perfil == 16 ? 'Nóminas firmadas' : 'Estatus'} body={bodyTemplateEstatus} />
                        <Column header='Folio' body={option => bodyTemplateFolio(option.Folio)} />
                        {perfil !== 16 && <Column header='Tipo' body={option => bodyTemplateTipoMaquila(option)} />}
                        {perfil !== 16 && <Column header='Municipio' body={option => bodyTemplateMunicipio(option.Municipio)} />}
                        <Column header='Creación - Modificación' body={option => option.fechaCreacion + ' - ' + option.fechaModificacion} />
                        <Column header='Acciones' body={bodyTemplate} />
                    </DataTable>
                </div>
            </div>







            <Dialog id='modalCancelacion' breakpoints={{ '641px': '90vw' }} style={{ width: '50vw', minHeight: '310px' }} blockScroll={true} closable={!guardandoMaquila || showCloseButton || isPaused || !isStarted} resizable={false} draggable={false} visible={nuevaMaquila} modal onHide={() => banderaOnHide()}
                header={
                    <div className='grid'>
                        <div className='text-left col-3' style={{ fontSize: '13px', fontWeight: '300' }}>
                            {/*   {objFolioMaquila !== null &&
                                <>
                                    <i className='pi pi-tag' style={{ fontSize: '15px', marginRight: '10px' }}></i><label>Folio {objFolioMaquila !== null ? objFolioMaquila.Folio : ''}</label>
                                </>
                            }*/}
                        </div>
                        <div className='text-center col-6'>NUEVA MAQUILA</div>
                        <div className='text-center col-3'></div>
                    </div>}                 >

                <div>
                    {guardandoMaquila !== true ?
                        <>
                            <div className="p-fluid formgrid grid">
                                <div className='col-12 text-right' style={{ color: 'red' }}>* Campos obligatorios</div>

                                <div className="field col-12 md:col-12">
                                    <label htmlFor="selectTipo"><label style={{ color: 'red' }}>*</label> Tipo:</label>
                                    <Dropdown id="selectTipo" name="selectTipo" value={tipoMaquila} options={lstGetTipoMaquilas} optionLabel='TipoMaquila' onChange={e => { setTipoMaquila(e.value); setSelectedItems(null); /*setSelectedUniverso(null);*/ }} />
                                </div>

                                <div className="field col-12 md:col-12">
                                    <label htmlFor="tipo"><label style={{ color: 'red' }}>*</label> {tipoMaquila !== null && tipoMaquila.TipoMaquila}:</label>
                                    <Dropdown key={lstMaquilaItems.length} disabled={loadingMaquilas} virtualScrollerOptions={{ itemSize: 38 }} optionDisabled="disabled" emptyFilterMessage="Sin resultados" id="tipo" name="tipo" filter value={selectedItems} options={lstMaquilaItems}
                                        placeholder={placeholderTemplateValorMaquila(tipoMaquila)}
                                        optionLabel='Descripcion' onChange={e => setSelectedItems(e.value)}
                                        style={{ height: '34.5px' }} />
                                </div>
                                {/* {tipoMaquila !== null && tipoMaquila.idTipoMaquila === 5 &&
                                    <div className="field col-12 md:col-12">
                                        <label htmlFor="universo"><label style={{ color: 'red' }}>*</label> Universo:</label>
                                        <Dropdown key={setLstUniversoItems.length} optionDisabled="disabled" emptyFilterMessage="Sin resultados" id="universo" name="universo" filter value={selectedUniverso} options={lstUniversoItems} placeholder='Seleccione universo' optionLabel='Descripcion' onChange={e => setSelectedUniverso(e.value)} />
                                    </div>
                                } */}
                            </div>
                            <div className="px-4 py-3 text-right">
                                <Button label="Cancelar" disabled={loadingNuevaMaquila} className='mr-3 p-button-outlined' icon='pi pi-times' align="right" onClick={() => onHide('nuevaMaquila')}></Button>
                                <Button label="Guardar" loading={loadingNuevaMaquila} className='p-button-component' icon='pi pi-check' onClick={confirmarMaquila} align="right"></Button>
                            </div>
                        </> :
                        <>
                            <div className='grid p-3'>
                                <div className='col-12 pt-6 flex'>
                                    <div className='col-6'>
                                        <h5 className='mb-0'>{progress === "100.00" ? 'Pendientes enviados con éxito' :
                                            isPaused ? 'Envío a pendientes pausado' : 'Enviando a pendientes...'}</h5>
                                    </div>
                                    <div className='col-6'>
                                        {(isPaused || progress === "100.00") &&
                                            <div style={{ textAlign: 'right' }}>
                                                <Tooltip target=".p-tooltip-target" />
                                                <img className='p-tooltip-target' data-pr-tooltip='Descargar CTs' src={excelLogo} onClick={() => obtenerReporte(objFolioMaquila)} style={{ height: "25px", cursor: "pointer" }} />
                                            </div>
                                        }
                                        {(!isPaused && progress !== "100.00") &&
                                            <div style={{ textAlign: 'right' }}>
                                                <ProgressSpinner style={{ height: "25px", marginRight: '-25px', display: 'block' }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className="progress-bar-container">
                                        <ProgressBar value={progress} showValue={false}></ProgressBar>
                                        <div className="progress-bar-label" style={{ color: '#000000', fontWeight: 400, fontSize: '14px', textShadow: '0 0 black' }}>{progress2}/{MaquilaItems.length}</div>
                                    </div>
                                    {/* <ProgressBar value={progress} displayValueTemplate={(value) => <p style={{ color: 'white' }}>{progress2}/{MaquilaItems.length}</p>} /> */}
                                </div>
                            </div>
                            <div className="px-4 py-3 text-right">
                                {!isStarted ? (
                                    ''/* <Button label='Iniciar' onClick={() => setIsStarted(true)} /> */
                                ) : (
                                    currentIndex < MaquilaItems.length && (
                                        <Button label={isPausing ? "Cargando..." : isPaused ? "Reanudar" : "Pausar"} disabled={isPausing} onClick={handlePause} />
                                    )
                                )}
                            </div>
                        </>
                    }
                </div>
            </Dialog>

            <Dialog id='modalCancelacion' breakpoints={{ '641px': '90vw' }} style={{ width: '50vw', minHeight: '310px' }} blockScroll={true} closable={!guardandoMaquila || showCloseButton || isPausedCierre || !isStartedCierre} resizable={false} draggable={false} visible={cierreMaquila} modal onHide={() => banderaOnHide()}
                header={
                    <div className='grid'>
                        <div className='text-left col-3' style={{ fontSize: '13px', fontWeight: '300' }}>
                            {objFolioMaquila !== null &&
                                <>
                                    <i className='pi pi-tag' style={{ fontSize: '15px', marginRight: '10px' }}></i><label>Folio {objFolioMaquila !== null ? objFolioMaquila.Folio : ''}</label>
                                </>
                            }
                        </div>
                        <div className='text-center col-6'>CIERRE DE ENTREGAS</div>
                        <div className='text-center col-3'></div>
                    </div>}>
                <>
                    <div className='grid p-3'>
                        <div className='col-12 pt-6 flex'>
                            <div className='col-6'>
                                <h5 className='mb-0'>{progressCierre === "100.00" ? 'Cierre de entregas realizado con éxito' :
                                    isPausedCierre ? 'Cierre de entregas pausado' : 'Cerrando entregas...'}</h5>
                            </div>
                            <div className='col-6'>
                                {(isPausedCierre || progressCierre === "100.00") &&
                                    <div style={{ textAlign: 'right' }}>
                                        <Tooltip target=".p-tooltip-target" />
                                        <img className='p-tooltip-target' data-pr-tooltip='Descargar CTs' src={excelLogo} onClick={() => obtenerReporte(objFolioMaquila)} style={{ height: "25px", cursor: "pointer" }} />
                                    </div>
                                }
                                {(!isPausedCierre && progressCierre !== "100.00") &&
                                    <div style={{ textAlign: 'right' }}>
                                        <ProgressSpinner style={{ height: "25px", marginRight: '-25px', display: 'block' }} />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='col-12'>
                            <div className="progress-bar-container">
                                <ProgressBar value={progressCierre} showValue={false}></ProgressBar>
                                <div className="progress-bar-label" style={{ color: '#000000', fontWeight: 400, fontSize: '14px', textShadow: '0 0 black' }}>{progress2Cierre}/{MaquilaItemsCierre.length}</div>
                            </div>
                            {/* <ProgressBar value={progress} displayValueTemplate={(value) => <p style={{ color: 'white' }}>{progress2}/{MaquilaItems.length}</p>} /> */}
                        </div>
                    </div>
                    <div className="px-4 py-3 text-right">
                        {!isStartedCierre ? (
                            ''/* <Button label='Iniciar' onClick={() => setIsStarted(true)} /> */
                        ) : (
                            currentIndexCierre < MaquilaItemsCierre.length && (
                                <Button label={isPausingCierre ? "Cargando..." : isPausedCierre ? "Reanudar" : "Pausar"} disabled={isPausingCierre} onClick={handlePauseCierre} />
                            )
                        )}
                    </div>
                </>
            </Dialog>

            <Dialog
                header={
                    <div className='grid'>
                        <div className='text-left col-3' style={{ fontSize: '14px', fontWeight: '400' }}><i className='pi pi-tag' style={{ fontSize: '15px', marginRight: '10px' }}></i>{`Folio ${detalleFolio !== null ? detalleFolio.Folio : ""}`}</div>
                        <div className='text-center col-6'>DETALLE DE FOLIO</div>
                        <div className='text-center col-3'></div>
                    </div>}
                id='modalCancelacion'
                blockScroll={true}
                resizable={false}
                draggable={false}
                visible={detalleMaquila}
                style={{ width: '80%', height: '90%' }}
                modal
                onHide={() => { onHide('detalleMaquila'); obtenerFolios() }}>

                <div className='row'>
                    <div className='col-12'>
                        <DataTable value={detalleFolio !== null ? [detalleFolio] : []} responsiveLayout={false} size="small" style={{ border: "solid 1px lightgray", marginTop: "10px", marginBottom: "10px", fontWeight: "bold" }}>
                            <Column field='Folio' header="Folio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                            <Column field='Municipio' header="Municipio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                            {perfil !== 16 && <Column header="Tipo maquila" body={bodyTemplateTipoMaq} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>}
                            <Column header="Estatus" field='Estatus' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                            {perfil !== 16 && <Column header="Total CTs" field='totalcts' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>}
                            {perfil !== 16 && <Column header="Descargar CTs" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }} body={rowData =>
                                <div className="App">
                                    <Button rounded text style={{ padding: '4px' }} onClick={() => obtenerReporte(rowData)} >
                                        <img src={excelLogo} style={{ height: "18px", cursor: "pointer" }} />
                                    </Button>
                                </div>
                            }></Column>}
                        </DataTable>
                        <div className='col-12 border-2 border-round border-gray-200'>
                            <div className='m-3'>
                                {cargandoDetalle || procesosFolio === null ? (
                                    "Cargando detalle..."
                                ) : (
                                    (procesosFolio.map((item, index) =>
                                        <div key={index}>
                                            <div className='grid'>

                                                <div className='col-11'>
                                                    <div className="font-bold flex">{`${index + 1} .-`}<div> </div><div dangerouslySetInnerHTML={{ __html: item.Pasos }} /></div>
                                                    <br />
                                                    <div dangerouslySetInnerHTML={{ __html: item.comentario }} />
                                                    <div dangerouslySetInnerHTML={{ __html: item.Resolucion }} />

                                                </div>

                                                {/* <Tooltip target=".custom-target-label" /> */}

                                                <div className='col-1' style={{ textAlign: 'center', alignSelf: 'center' }}>
                                                    <Tooltip target=".p-tooltip-target" />
                                                    {item.Adjuntos == 0 ? <i ></i> : <i className='adjuntoMaquilaIcon pi pi-paperclip mr-1 p-tooltip-target' data-pr-tooltip="Ver adjuntos" style={{ cursor: 'pointer', fontSize: '23px' }} onClick={() => (item.idResolucionUltima !== 7 || detalleFolio.idTipoMaquila === 1) ? Adjuntos(item) : openDialog("dialogDocumentCT")} ></i>}
                                                </div>


                                            </div>
                                            {item.evidencias && <Button className="p-button-outlined mt-3" label={!openEvidencias.includes(index) ? "Ver más" : "Ver menos"} icon={!openEvidencias.includes(index) ? "pi pi-plus" : "pi pi-minus"} onClick={() => toggleEvidencias(index)} style={{ height: '30px' }} />}
                                            {item.evidencias && openEvidencias.includes(index) && item.evidencias.map((itemJ, indexJ) =>
                                                <div key={`${index}${indexJ}`}>
                                                    <div className='grid m-3'>

                                                        <div className='col-11'>
                                                            <div className="font-bold" dangerouslySetInnerHTML={{ __html: itemJ.Pasos }} />
                                                            <br />
                                                            <div dangerouslySetInnerHTML={{ __html: itemJ.comentario }} />
                                                            <div dangerouslySetInnerHTML={{ __html: itemJ.Resolucion }} />

                                                        </div>

                                                        {/* <Tooltip target=".custom-target-label" /> */}

                                                    </div>
                                                    <hr style={{ border: '1px solid lightgray' }} />

                                                </div>
                                            )}
                                            <hr style={{ border: '1px solid lightgray' }} />
                                        </div>

                                        // <div className='mb-2' key={index}>
                                        //     <div dangerouslySetInnerHTML={{ __html: item.Pasos }} />
                                        //     <div dangerouslySetInnerHTML={{ __html: item.Resolucion }} />
                                        // </div>
                                    ))

                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                blockScroll={true}
                resizable={false}
                draggable={false}
                visible={gestionMaquila}
                style={{ width: '80%', height: '90%' }}
                modal
                closable={!cargandoEvidencias}
                onHide={() => onHide('gestionMaquila')}
                header={
                    <div className='grid'>
                        <div className='text-left col-3' style={{ fontSize: '14px', fontWeight: '400' }}><i className='pi pi-tag' style={{ fontSize: '15px', marginRight: '10px' }}></i>{`Folio ${detalleFolio !== null ? detalleFolio.Folio : ""}`}</div>
                        <div className='text-center col-6'>GESTIÓN DE FOLIO</div>
                        <div className='text-center col-3'></div>
                    </div>
                }
                footer={
                    <div className="px-4 py-3 text-right">
                        {mostrarProgresoEvidencias ?
                            <>
                                {cargandoEvidencias && !pausado && (
                                    <Button
                                        className="p-button"
                                        loading={pausaSolicitada}
                                        label="Pausar"
                                        onClick={pausarCarga}
                                    />
                                )}

                                {pausado && !procesoCompletado && (
                                    <Button
                                        className="p-button"
                                        label="Reanudar"
                                        onClick={reanudarCarga}
                                    />
                                )}
                            </>
                            :
                            <>
                                <Button className='p-button-outlined' disabled={loadingGuardado} type='button' icon='pi pi-times' label='Cancelar' onClick={() => onHide("gestionMaquila")} style={{ marginRight: '1%' }} />
                                <Button className='p-button' loading={loadingGuardado} icon='pi pi-check' label='Guardar' style={{ marginRight: '1%' }} onClick={handleConfirmarGestion} />
                            </>
                        }
                    </div>
                }
            >

                <form onSubmit={handleConfirmarGestion}>
                    <div className='row'>
                        {mostrarProgresoEvidencias ?
                            progresoEvidenciasTemplate()
                            :
                            (
                                <div className='col-12'>
                                    <DataTable id='tablaDetalleLicencias' value={detalleFolio !== null ? [detalleFolio] : []} responsiveLayout={false} size="small" style={{ border: "solid 1px lightgray", marginTop: "10px", marginBottom: "10px", fontWeight: "bold" }}>
                                        <Column field='Folio' header="Folio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }}></Column>
                                        <Column field='Municipio' header="Municipio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }}></Column>
                                        {perfil !== 16 && <Column header="Tipo maquila" body={bodyTemplateTipoMaq} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }}></Column>}
                                        <Column header="Estatus" field='Estatus' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }}></Column>
                                        {/*    {detalleFolio !== null && detalleFolio.idEstatusMaquila === 8 && 
                                <Column header="Reanudar envío" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }} body={rowData =>
                                    <div className="App">
                                        <Tooltip target=".p-tooltip-target" />
                                        <Button className="p-tooltip-target" data-pr-tooltip="Enviar alumnos a Pendientes" icon='pi pi-refresh' type='button' rounded text onClick={() => reanudarMaquila(rowData)} />
                                    </div>
                                }></Column>} */}
                                        {perfil !== 16 && <Column header="Total CTs" field='totalcts' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>}
                                        {perfil !== 16 && <Column header="Descargar CTs" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} style={{ textAlign: "center" }} body={rowData =>
                                            <div className="App">
                                                <Button rounded text type='button' style={{ padding: '4px' }} onClick={() => obtenerReporte(rowData)} >
                                                    <img src={excelLogo} style={{ height: "18px", cursor: "pointer" }} />
                                                </Button>
                                            </div>
                                        }></Column>}
                                    </DataTable>
                                    <div className='col-12'>
                                        <div className='m-3'>
                                            <div className='col-12 text-right pb-0' style={{ color: 'red' }}>* Campos obligatorios</div>
                                            {resolucion === null ? (
                                                "Cargando solicitud..."
                                            ) : (
                                                <div className='grid'>
                                                    <div className={[4, 5].includes(resolucion) ? 'col-12 lg:col-6' : 'col-12'}>
                                                        <label htmlFor="resolucion" style={{ fontWeight: '600' }}>Resolución</label>
                                                        <Dropdown className='w-full' id='resolucion' name='resolucion' value={resolucion} options={getResolucion} optionValue='idResolucion' optionLabel='Resolucion' onChange={e => setResolucion(e.value)} />
                                                    </div>
                                                    {obtenerForm(resolucion)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                </form>
            </Dialog>

            <Dialog
                visible={alumnosDialog}
                header='CONFIRMACIÓN'
                breakpoints={{ '641px': '90vw' }}
                style={{ width: '50vw', minHeight: '310px' }}
                blockScroll={true}
                draggable={false}
                closable={false}
                footer={footerAlumno}>

                {pendientes !== null &&
                    <div className="grid m-2 ml-3 mb-0" >
                        <div className="col-2 text-center mt-8 pb-0" >
                            <i className="pi pi-exclamation-triangle text-6xl md:text-8xl lg:text-8xl" style={{ color: '#9b2f3e' }} />
                        </div>
                        <div className="col-8 text-center" >
                            <div className="mt-5">
                                <label className="text-m font-bold block" style={{ color: '#9b2f3e' }}>Total alumnos: {pendientes.TotalPendientes}</label>
                                <label className="text-m  block" >Total de escuelas: {pendientes.TotalCT}</label>
                            </div>
                            <div className="mt-5">
                                <label className="text-m block">Esto podría generar sobrecarga al sistema,</label>
                                <label className="text-m block" style={{ fontWeight: 'bold' }}>¿está seguro de enviar {pendientes.TotalPendientes} alumnos a pendientes?</label>
                            </div>
                        </div>
                        <div className="col-2" ></div>
                    </div>}
            </Dialog>

            <Dialog
                header={
                    <div style={{ textAlign: "center", backgroundColor: '#9b2f3e', color: "white", fontSize: '16px', padding: 1 }}>
                        CONFIRMACIÓN
                    </div>
                }
                breakpoints={{ '641px': '90vw' }}
                style={{ width: '30vw', minHeight: '200px' }}
                blockScroll={true}
                visible={dialogConfirmar}
                closable={false}
                draggable={false}
                footer={
                    <div className='p-component-modal-tabla' >
                        <div style={{ justifyContent: 'center' }}>
                            <Button label="NO" disabled={loadingGuardado} className="p-button-outlined" style={{ width: '100px' }} onClick={() => { onHide("dialogConfirmar"); }} />
                            <Button label="SÍ" loading={loadingGuardado} className="p-button" style={{ width: '100px' }} onClick={handleGestionMaquila} />
                        </div>
                    </div>
                }
            >
                <div className="grid m-2 ml-3 mb-0">
                    {(![20].includes(perfil) && ![4].includes(resolucion)) ?
                        <div className='col-12 text-center'>
                            <h5>¿Desea continuar con el guardado?</h5>
                        </div>
                        :
                        <>
                            <div className="col-2 text-center mt-8 pb-0" >
                                <i className="pi pi-exclamation-triangle text-6xl md:text-8xl lg:text-8xl" style={{ color: '#9b2f3e' }} />
                            </div>
                            <div className="col-8 text-center" >
                                <div className="mt-5">
                                    <label className="text-m  block">La evidencia se registrará para los <label style={{ color: '#9b2f3e', fontWeight: '700' }}>{totalAlumnos} alumnos</label> de las <label style={{ color: '#9b2f3e', fontWeight: '700' }}>{form.cts.length} escuelas </label> seleccionadas.</label>
                                </div>
                                <div className="mt-5">
                                    <label className="text-m font-bold block">Esto podría generar sobrecarga al sistema, ¿desea continuar?</label>
                                </div>
                            </div>
                            <div className="col-2" ></div>
                        </>}
                </div>

            </Dialog >



            <Sidebar
                fullScreen
                visible={loadingDescarga}
                style={{ background: 'lightgray', opacity: '60%' }}
                showCloseIcon={false}>
                <div className="text-center" style={{ marginTop: '200px' }}>
                    <ProgressSpinner />
                    <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>{`Descargando ${tipoDescarga}...`}</strong></div>
                </div>
            </Sidebar>

            <Sidebar
                fullScreen
                visible={loadingPendientes}
                style={{ background: 'lightgray', opacity: '60%' }}
                showCloseIcon={false}>
                <div className="text-center" style={{ marginTop: '200px' }}>
                    <ProgressSpinner />
                    <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>Obteniendo pendientes...</strong></div>
                </div>
            </Sidebar>

            <Dialog
                header='CARGANDO PDF'
                blockScroll={true}
                visible={descargarReporte}
                closable={false}
                breakpoints={{ "991px": "90%" }}
                style={{ width: "80%", height: "90%" }}
                showHeader={false}
                contentStyle={{ background: 'lightgray', opacity: '60%' }}
                draggable={false}
            >
                <div className="text-center" style={{ marginTop: '200px' }}>
                    <ProgressSpinner />
                    <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>Descargando reporte...</strong></div>
                </div>
            </Dialog>

            <Dialog breakpoints={{ '641px': '90vw' }} style={{ width: '500px' }} blockScroll={true} closable={false} resizable={false} draggable={false} visible={dialogSupervisiones} modal
                header={
                    <div className='grid'>
                        <div className='text-left col-3' style={{ fontSize: '13px', fontWeight: '300' }} />
                        <div className='text-center col-6'>NÓMINA</div>
                        <div className='text-center col-3'></div>
                    </div>}
                footer={
                    <div className='p-component-modal-tabla' >
                        <div style={{ justifyContent: 'center' }}>
                            <Button label="Cancelar" className="p-button-outlined" icon='pi pi-times' disabled={loadingNomina} style={{ width: '100px' }} onClick={() => { onHide('dialogSupervisiones'); setSelectedSup(null); setSupervisiones([]); setDetalleFolio(null); }} />
                            <Button label="Descargar" className="p-button" icon='pi pi-check' loading={loadingNomina} style={{ width: '100px' }} onClick={() => obtenerPDF()} />
                        </div>
                    </div>
                }>
                <div className='grid'>
                    <div className='col-12 text-right' style={{ color: 'red' }}>* Campos obligatorios</div>

                    <div className='col-12'>
                        <label htmlFor="supervision"><label style={{ color: 'red' }}>*</label> Supervisión:</label>
                        <Dropdown id='supervision' name='supervision' className='w-full' placeholder='Seleccione' value={selectedSup} options={supervisiones} optionLabel='valor' onChange={e => setSelectedSup(e.value)} />
                    </div>
                </div>
            </Dialog>

            <DialogDocumento header="VISUALIZACIÓN DE ADJUNTOS" visible={dialogDocument} onHide={() => onHide('dialogDocument')} data={documentos} idUsuario={id} idUsuarioPerfil={perfil}></DialogDocumento>

            <DialogDocumentoCT header="VISUALIZACIÓN DE ADJUNTOS" visible={dialogDocumentCT} onHide={() => onHide('dialogDocumentCT')} ciclo={ciclo} idUsuario={id} idUsuarioPerfil={perfil} topContent={detalleFolio} obtenerReporte={e => obtenerReporte(e)}></DialogDocumentoCT>

            <DialogEditarEvidencia visible={openDialogEvidencia} data={dataEvidencias} onHide={() => {
                onHide('openDialogEvidencia');
                setDataEvidencias(null);
                obtenerFolios();
            }} />
        </div>
    )
}

export default DashboardMaquila;